!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/dds"), require("redux"), require("react-redux"), require("@driftt/web-auth"), require("react-dom"), require("@driftt/tide-icons"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/dds", "redux", "react-redux", "@driftt/web-auth", "react-dom", "@driftt/tide-icons"], t);else {
    var r = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/dds"), require("redux"), require("react-redux"), require("@driftt/web-auth"), require("react-dom"), require("@driftt/tide-icons")) : t(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/dds"], e.redux, e["react-redux"], e["@driftt/web-auth"], e["react-dom"], e["@driftt/tide-icons"]);
    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r, n, o, i, a, c, u) {
  return function (e) {
    var t = {};
    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 29);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    function invariant(e, t) {
      for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++) {
        n[o - 2] = arguments[o];
      }
      if (!e) {
        var i;
        if (void 0 === t) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var a = 0;
          (i = new Error(t.replace(/%s/g, function () {
            return n[a++];
          }))).name = "Invariant Violation";
        }
        throw i.framesToPop = 1, i;
      }
    }
    r.d(t, "a", function () {
      return invariant;
    });
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, r) {
    var n;
    !function () {
      "use strict";

      var r = {}.hasOwnProperty;
      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          if (n) {
            var o = typeof n;
            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n) && n.length) {
              var i = classNames.apply(null, n);
              i && e.push(i);
            } else if ("object" === o) for (var a in n) {
              r.call(n, a) && n[a] && e.push(a);
            }
          }
        }
        return e.join(" ");
      }
      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (n = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, r) {
    "use strict";

    e.exports = function invariant(e, t, r, n, o, i, a, c) {
      if (!e) {
        var u;
        if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var s = [r, n, o, i, a, c],
            l = 0;
          (u = new Error(t.replace(/%s/g, function () {
            return s[l++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    };
  }, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
      o = r(6),
      i = "dnd-core/INIT_COORDS",
      a = "dnd-core/BEGIN_DRAG",
      c = "dnd-core/PUBLISH_DRAG_SOURCE",
      u = "dnd-core/HOVER",
      s = "dnd-core/DROP",
      l = "dnd-core/END_DRAG",
      d = function strictEquality(e, t) {
        return e === t;
      };
    function ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function _objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
          _defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function _defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var f = {
      initialSourceClientOffset: null,
      initialClientOffset: null,
      clientOffset: null
    };
    function reduce() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f,
        t = arguments.length > 1 ? arguments[1] : void 0,
        r = t.payload;
      switch (t.type) {
        case i:
        case a:
          return {
            initialSourceClientOffset: r.sourceClientOffset,
            initialClientOffset: r.clientOffset,
            clientOffset: r.clientOffset
          };
        case u:
          return function areCoordsEqual(e, t) {
            return !e && !t || !(!e || !t) && e.x === t.x && e.y === t.y;
          }(e.clientOffset, r.clientOffset) ? e : _objectSpread(_objectSpread({}, e), {}, {
            clientOffset: r.clientOffset
          });
        case l:
        case s:
          return f;
        default:
          return e;
      }
    }
    var p = "dnd-core/ADD_SOURCE",
      h = "dnd-core/ADD_TARGET",
      g = "dnd-core/REMOVE_SOURCE",
      b = "dnd-core/REMOVE_TARGET";
    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function isObject(e) {
      return "object" === _typeof(e);
    }
    function dragOperation_ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function dragOperation_objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? dragOperation_ownKeys(Object(r), !0).forEach(function (t) {
          dragOperation_defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dragOperation_ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function dragOperation_defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var y = {
      itemType: null,
      item: null,
      sourceId: null,
      targetIds: [],
      dropResult: null,
      didDrop: !1,
      isSourcePublic: null
    };
    function dragOperation_reduce() {
      var e,
        t,
        r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : y,
        n = arguments.length > 1 ? arguments[1] : void 0,
        o = n.payload;
      switch (n.type) {
        case a:
          return dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            itemType: o.itemType,
            item: o.item,
            sourceId: o.sourceId,
            isSourcePublic: o.isSourcePublic,
            dropResult: null,
            didDrop: !1
          });
        case c:
          return dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            isSourcePublic: !0
          });
        case u:
          return dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            targetIds: o.targetIds
          });
        case b:
          return -1 === r.targetIds.indexOf(o.targetId) ? r : dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            targetIds: (e = r.targetIds, t = o.targetId, e.filter(function (e) {
              return e !== t;
            }))
          });
        case s:
          return dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            dropResult: o.dropResult,
            didDrop: !0,
            targetIds: []
          });
        case l:
          return dragOperation_objectSpread(dragOperation_objectSpread({}, r), {}, {
            itemType: null,
            item: null,
            sourceId: null,
            dropResult: null,
            didDrop: !1,
            isSourcePublic: null,
            targetIds: []
          });
        default:
          return r;
      }
    }
    function refCount_reduce() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      switch ((arguments.length > 1 ? arguments[1] : void 0).type) {
        case p:
        case h:
          return e + 1;
        case g:
        case b:
          return e - 1;
        default:
          return e;
      }
    }
    var v = [],
      m = [];
    function dirtyHandlerIds_reduce() {
      arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      var e = arguments.length > 1 ? arguments[1] : void 0;
      switch (e.type) {
        case u:
          break;
        case p:
        case h:
        case b:
        case g:
          return v;
        case a:
        case c:
        case l:
        case s:
        default:
          return m;
      }
      var t = e.payload,
        r = t.targetIds,
        n = void 0 === r ? [] : r,
        o = t.prevTargetIds,
        i = void 0 === o ? [] : o,
        f = function xor(e, t) {
          var r = new Map(),
            n = function insertItem(e) {
              r.set(e, r.has(e) ? r.get(e) + 1 : 1);
            };
          e.forEach(n), t.forEach(n);
          var o = [];
          return r.forEach(function (e, t) {
            1 === e && o.push(t);
          }), o;
        }(n, i);
      if (!(f.length > 0 || !function areArraysEqual(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : d;
        if (e.length !== t.length) return !1;
        for (var n = 0; n < e.length; ++n) {
          if (!r(e[n], t[n])) return !1;
        }
        return !0;
      }(n, i))) return v;
      var y = i[i.length - 1],
        O = n[n.length - 1];
      return y !== O && (y && f.push(y), O && f.push(O)), f;
    }
    function stateId_reduce() {
      return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0) + 1;
    }
    function reducers_ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function reducers_objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? reducers_ownKeys(Object(r), !0).forEach(function (t) {
          reducers_defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : reducers_ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function reducers_defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function reducers_reduce() {
      var e,
        t,
        r,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        o = arguments.length > 1 ? arguments[1] : void 0;
      return {
        dirtyHandlerIds: dirtyHandlerIds_reduce(n.dirtyHandlerIds, {
          type: o.type,
          payload: reducers_objectSpread(reducers_objectSpread({}, o.payload), {}, {
            prevTargetIds: (e = n, t = "dragOperation.targetIds", r = [], t.split(".").reduce(function (e, t) {
              return e && e[t] ? e[t] : r || null;
            }, e))
          })
        }),
        dragOffset: reduce(n.dragOffset, o),
        refCount: refCount_reduce(n.refCount, o),
        dragOperation: dragOperation_reduce(n.dragOperation, o),
        stateId: stateId_reduce(n.stateId)
      };
    }
    v.__IS_NONE__ = !0, m.__IS_ALL__ = !0;
    var O = r(1);
    function setClientOffset(e, t) {
      return {
        type: i,
        payload: {
          sourceClientOffset: t || null,
          clientOffset: e || null
        }
      };
    }
    var S = {
      type: i,
      payload: {
        clientOffset: null,
        sourceClientOffset: null
      }
    };
    function createBeginDrag(e) {
      return function beginDrag() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            publishSource: !0
          },
          n = r.publishSource,
          o = void 0 === n || n,
          i = r.clientOffset,
          c = r.getSourceClientOffset,
          u = e.getMonitor(),
          s = e.getRegistry();
        e.dispatch(setClientOffset(i)), function verifyInvariants(e, t, r) {
          Object(O.a)(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function (e) {
            Object(O.a)(r.getSource(e), "Expected sourceIds to be registered.");
          });
        }(t, u, s);
        var l = function getDraggableSource(e, t) {
          for (var r = null, n = e.length - 1; n >= 0; n--) {
            if (t.canDragSource(e[n])) {
              r = e[n];
              break;
            }
          }
          return r;
        }(t, u);
        if (null !== l) {
          var d = null;
          if (i) {
            if (!c) throw new Error("getSourceClientOffset must be defined");
            !function verifyGetSourceClientOffsetIsFunction(e) {
              Object(O.a)("function" === typeof e, "When clientOffset is provided, getSourceClientOffset must be a function.");
            }(c), d = c(l);
          }
          e.dispatch(setClientOffset(i, d));
          var f = s.getSource(l).beginDrag(u, l);
          !function verifyItemIsObject(e) {
            Object(O.a)(isObject(e), "Item must be an object.");
          }(f), s.pinSource(l);
          var p = s.getSourceType(l);
          return {
            type: a,
            payload: {
              itemType: p,
              item: f,
              sourceId: l,
              clientOffset: i || null,
              sourceClientOffset: d || null,
              isSourcePublic: !!o
            }
          };
        }
        e.dispatch(S);
      };
    }
    function createPublishDragSource(e) {
      return function publishDragSource() {
        if (e.getMonitor().isDragging()) return {
          type: c
        };
      };
    }
    function matchesType(e, t) {
      return null === t ? null === e : Array.isArray(e) ? e.some(function (e) {
        return e === t;
      }) : e === t;
    }
    function createHover(e) {
      return function hover(t) {
        var r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).clientOffset;
        !function verifyTargetIdsIsArray(e) {
          Object(O.a)(Array.isArray(e), "Expected targetIds to be an array.");
        }(t);
        var n = t.slice(0),
          o = e.getMonitor(),
          i = e.getRegistry();
        return function checkInvariants(e, t, r) {
          Object(O.a)(t.isDragging(), "Cannot call hover while not dragging."), Object(O.a)(!t.didDrop(), "Cannot call hover after drop.");
          for (var n = 0; n < e.length; n++) {
            var o = e[n];
            Object(O.a)(e.lastIndexOf(o) === n, "Expected targetIds to be unique in the passed array.");
            var i = r.getTarget(o);
            Object(O.a)(i, "Expected targetIds to be registered.");
          }
        }(n, o, i), function removeNonMatchingTargetIds(e, t, r) {
          for (var n = e.length - 1; n >= 0; n--) {
            var o = e[n],
              i = t.getTargetType(o);
            matchesType(i, r) || e.splice(n, 1);
          }
        }(n, i, o.getItemType()), function hoverAllTargets(e, t, r) {
          e.forEach(function (e) {
            var n = r.getTarget(e);
            n.hover(t, e);
          });
        }(n, o, i), {
          type: u,
          payload: {
            targetIds: n,
            clientOffset: r || null
          }
        };
      };
    }
    function drop_ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function drop_objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? drop_ownKeys(Object(r), !0).forEach(function (t) {
          drop_defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : drop_ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function drop_defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function createDrop(e) {
      return function drop() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = e.getMonitor(),
          n = e.getRegistry();
        !function drop_verifyInvariants(e) {
          Object(O.a)(e.isDragging(), "Cannot call drop while not dragging."), Object(O.a)(!e.didDrop(), "Cannot call drop twice during one drag operation.");
        }(r), function getDroppableTargets(e) {
          var t = e.getTargetIds().filter(e.canDropOnTarget, e);
          return t.reverse(), t;
        }(r).forEach(function (o, i) {
          var a = function determineDropResult(e, t, r, n) {
              var o = r.getTarget(e),
                i = o ? o.drop(n, e) : void 0;
              (function verifyDropResultType(e) {
                Object(O.a)("undefined" === typeof e || isObject(e), "Drop result must either be an object or undefined.");
              })(i), "undefined" === typeof i && (i = 0 === t ? {} : n.getDropResult());
              return i;
            }(o, i, n, r),
            c = {
              type: s,
              payload: {
                dropResult: drop_objectSpread(drop_objectSpread({}, t), a)
              }
            };
          e.dispatch(c);
        });
      };
    }
    function createEndDrag(e) {
      return function endDrag() {
        var t = e.getMonitor(),
          r = e.getRegistry();
        !function verifyIsDragging(e) {
          Object(O.a)(e.isDragging(), "Cannot call endDrag while not dragging.");
        }(t);
        var n = t.getSourceId();
        null != n && (r.getSource(n, !0).endDrag(t, n), r.unpinSource());
        return {
          type: l
        };
      };
    }
    function subtract(e, t) {
      return {
        x: e.x - t.x,
        y: e.y - t.y
      };
    }
    function _defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var _,
      A = function () {
        function DragDropMonitorImpl(e, t) {
          !function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, DragDropMonitorImpl), this.store = e, this.registry = t;
        }
        return function _createClass(e, t, r) {
          return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
        }(DragDropMonitorImpl, [{
          key: "subscribeToStateChange",
          value: function subscribeToStateChange(e) {
            var t = this,
              r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                handlerIds: void 0
              }).handlerIds;
            Object(O.a)("function" === typeof e, "listener must be a function."), Object(O.a)("undefined" === typeof r || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
            var n = this.store.getState().stateId;
            return this.store.subscribe(function handleChange() {
              var o = t.store.getState(),
                i = o.stateId;
              try {
                i === n || i === n + 1 && !function areDirty(e, t) {
                  return e !== v && (e === m || "undefined" === typeof t || function intersection(e, t) {
                    return e.filter(function (e) {
                      return t.indexOf(e) > -1;
                    });
                  }(t, e).length > 0);
                }(o.dirtyHandlerIds, r) || e();
              } finally {
                n = i;
              }
            });
          }
        }, {
          key: "subscribeToOffsetChange",
          value: function subscribeToOffsetChange(e) {
            var t = this;
            Object(O.a)("function" === typeof e, "listener must be a function.");
            var r = this.store.getState().dragOffset;
            return this.store.subscribe(function handleChange() {
              var n = t.store.getState().dragOffset;
              n !== r && (r = n, e());
            });
          }
        }, {
          key: "canDragSource",
          value: function canDragSource(e) {
            if (!e) return !1;
            var t = this.registry.getSource(e);
            return Object(O.a)(t, "Expected to find a valid source."), !this.isDragging() && t.canDrag(this, e);
          }
        }, {
          key: "canDropOnTarget",
          value: function canDropOnTarget(e) {
            if (!e) return !1;
            var t = this.registry.getTarget(e);
            return Object(O.a)(t, "Expected to find a valid target."), !(!this.isDragging() || this.didDrop()) && matchesType(this.registry.getTargetType(e), this.getItemType()) && t.canDrop(this, e);
          }
        }, {
          key: "isDragging",
          value: function isDragging() {
            return Boolean(this.getItemType());
          }
        }, {
          key: "isDraggingSource",
          value: function isDraggingSource(e) {
            if (!e) return !1;
            var t = this.registry.getSource(e, !0);
            return Object(O.a)(t, "Expected to find a valid source."), !(!this.isDragging() || !this.isSourcePublic()) && this.registry.getSourceType(e) === this.getItemType() && t.isDragging(this, e);
          }
        }, {
          key: "isOverTarget",
          value: function isOverTarget(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              shallow: !1
            };
            if (!e) return !1;
            var r = t.shallow;
            if (!this.isDragging()) return !1;
            var n = this.registry.getTargetType(e),
              o = this.getItemType();
            if (o && !matchesType(n, o)) return !1;
            var i = this.getTargetIds();
            if (!i.length) return !1;
            var a = i.indexOf(e);
            return r ? a === i.length - 1 : a > -1;
          }
        }, {
          key: "getItemType",
          value: function getItemType() {
            return this.store.getState().dragOperation.itemType;
          }
        }, {
          key: "getItem",
          value: function getItem() {
            return this.store.getState().dragOperation.item;
          }
        }, {
          key: "getSourceId",
          value: function getSourceId() {
            return this.store.getState().dragOperation.sourceId;
          }
        }, {
          key: "getTargetIds",
          value: function getTargetIds() {
            return this.store.getState().dragOperation.targetIds;
          }
        }, {
          key: "getDropResult",
          value: function getDropResult() {
            return this.store.getState().dragOperation.dropResult;
          }
        }, {
          key: "didDrop",
          value: function didDrop() {
            return this.store.getState().dragOperation.didDrop;
          }
        }, {
          key: "isSourcePublic",
          value: function isSourcePublic() {
            return Boolean(this.store.getState().dragOperation.isSourcePublic);
          }
        }, {
          key: "getInitialClientOffset",
          value: function getInitialClientOffset() {
            return this.store.getState().dragOffset.initialClientOffset;
          }
        }, {
          key: "getInitialSourceClientOffset",
          value: function getInitialSourceClientOffset() {
            return this.store.getState().dragOffset.initialSourceClientOffset;
          }
        }, {
          key: "getClientOffset",
          value: function getClientOffset() {
            return this.store.getState().dragOffset.clientOffset;
          }
        }, {
          key: "getSourceClientOffset",
          value: function getSourceClientOffset() {
            return function coords_getSourceClientOffset(e) {
              var t = e.clientOffset,
                r = e.initialClientOffset,
                n = e.initialSourceClientOffset;
              return t && r && n ? subtract(function add(e, t) {
                return {
                  x: e.x + t.x,
                  y: e.y + t.y
                };
              }(t, n), r) : null;
            }(this.store.getState().dragOffset);
          }
        }, {
          key: "getDifferenceFromInitialOffset",
          value: function getDifferenceFromInitialOffset() {
            return function coords_getDifferenceFromInitialOffset(e) {
              var t = e.clientOffset,
                r = e.initialClientOffset;
              return t && r ? subtract(t, r) : null;
            }(this.store.getState().dragOffset);
          }
        }]), DragDropMonitorImpl;
      }(),
      w = 0;
    function contracts_typeof(e) {
      return (contracts_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function validateType(e, t) {
      t && Array.isArray(e) ? e.forEach(function (e) {
        return validateType(e, !1);
      }) : Object(O.a)("string" === typeof e || "symbol" === contracts_typeof(e), t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
    }
    !function (e) {
      e.SOURCE = "SOURCE", e.TARGET = "TARGET";
    }(_ || (_ = {}));
    var E = r(14),
      C = [],
      T = [],
      D = E.a.makeRequestCallFromTimer(function throwFirstError() {
        if (T.length) throw T.shift();
      });
    function asap(e) {
      var t;
      (t = C.length ? C.pop() : new I()).task = e, Object(E.a)(t);
    }
    var I = function () {
      function RawTask() {}
      return RawTask.prototype.call = function () {
        try {
          this.task.call();
        } catch (e) {
          asap.onerror ? asap.onerror(e) : (T.push(e), D());
        } finally {
          this.task = null, C[C.length] = this;
        }
      }, RawTask;
    }();
    function HandlerRegistryImpl_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function _unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return _arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _arrayLikeToArray(e, t);
      }(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function getNextHandlerId(e) {
      var t = function getNextUniqueId() {
        return w++;
      }().toString();
      switch (e) {
        case _.SOURCE:
          return "S".concat(t);
        case _.TARGET:
          return "T".concat(t);
        default:
          throw new Error("Unknown Handler Role: ".concat(e));
      }
    }
    function parseRoleFromHandlerId(e) {
      switch (e[0]) {
        case "S":
          return _.SOURCE;
        case "T":
          return _.TARGET;
        default:
          Object(O.a)(!1, "Cannot parse handler ID: ".concat(e));
      }
    }
    function mapContainsValue(e, t) {
      var r = e.entries(),
        n = !1;
      do {
        var o = r.next(),
          i = o.done;
        if (_slicedToArray(o.value, 2)[1] === t) return !0;
        n = !!i;
      } while (!n);
      return !1;
    }
    var j = function () {
      function HandlerRegistryImpl(e) {
        !function HandlerRegistryImpl_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, HandlerRegistryImpl), this.types = new Map(), this.dragSources = new Map(), this.dropTargets = new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
      }
      return function HandlerRegistryImpl_createClass(e, t, r) {
        return t && HandlerRegistryImpl_defineProperties(e.prototype, t), r && HandlerRegistryImpl_defineProperties(e, r), e;
      }(HandlerRegistryImpl, [{
        key: "addSource",
        value: function addSource(e, t) {
          validateType(e), function validateSourceContract(e) {
            Object(O.a)("function" === typeof e.canDrag, "Expected canDrag to be a function."), Object(O.a)("function" === typeof e.beginDrag, "Expected beginDrag to be a function."), Object(O.a)("function" === typeof e.endDrag, "Expected endDrag to be a function.");
          }(t);
          var r = this.addHandler(_.SOURCE, e, t);
          return this.store.dispatch(function registry_addSource(e) {
            return {
              type: p,
              payload: {
                sourceId: e
              }
            };
          }(r)), r;
        }
      }, {
        key: "addTarget",
        value: function addTarget(e, t) {
          validateType(e, !0), function validateTargetContract(e) {
            Object(O.a)("function" === typeof e.canDrop, "Expected canDrop to be a function."), Object(O.a)("function" === typeof e.hover, "Expected hover to be a function."), Object(O.a)("function" === typeof e.drop, "Expected beginDrag to be a function.");
          }(t);
          var r = this.addHandler(_.TARGET, e, t);
          return this.store.dispatch(function registry_addTarget(e) {
            return {
              type: h,
              payload: {
                targetId: e
              }
            };
          }(r)), r;
        }
      }, {
        key: "containsHandler",
        value: function containsHandler(e) {
          return mapContainsValue(this.dragSources, e) || mapContainsValue(this.dropTargets, e);
        }
      }, {
        key: "getSource",
        value: function getSource(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return Object(O.a)(this.isSourceId(e), "Expected a valid source ID."), t && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
        }
      }, {
        key: "getTarget",
        value: function getTarget(e) {
          return Object(O.a)(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
        }
      }, {
        key: "getSourceType",
        value: function getSourceType(e) {
          return Object(O.a)(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
        }
      }, {
        key: "getTargetType",
        value: function getTargetType(e) {
          return Object(O.a)(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
        }
      }, {
        key: "isSourceId",
        value: function isSourceId(e) {
          return parseRoleFromHandlerId(e) === _.SOURCE;
        }
      }, {
        key: "isTargetId",
        value: function isTargetId(e) {
          return parseRoleFromHandlerId(e) === _.TARGET;
        }
      }, {
        key: "removeSource",
        value: function removeSource(e) {
          var t = this;
          Object(O.a)(this.getSource(e), "Expected an existing source."), this.store.dispatch(function registry_removeSource(e) {
            return {
              type: g,
              payload: {
                sourceId: e
              }
            };
          }(e)), asap(function () {
            t.dragSources.delete(e), t.types.delete(e);
          });
        }
      }, {
        key: "removeTarget",
        value: function removeTarget(e) {
          Object(O.a)(this.getTarget(e), "Expected an existing target."), this.store.dispatch(function registry_removeTarget(e) {
            return {
              type: b,
              payload: {
                targetId: e
              }
            };
          }(e)), this.dropTargets.delete(e), this.types.delete(e);
        }
      }, {
        key: "pinSource",
        value: function pinSource(e) {
          var t = this.getSource(e);
          Object(O.a)(t, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = t;
        }
      }, {
        key: "unpinSource",
        value: function unpinSource() {
          Object(O.a)(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
        }
      }, {
        key: "addHandler",
        value: function addHandler(e, t, r) {
          var n = getNextHandlerId(e);
          return this.types.set(n, t), e === _.SOURCE ? this.dragSources.set(n, r) : e === _.TARGET && this.dropTargets.set(n, r), n;
        }
      }]), HandlerRegistryImpl;
    }();
    function DragDropManagerImpl_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var k = function () {
      function DragDropManagerImpl() {
        var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        !function DragDropManagerImpl_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, DragDropManagerImpl), this.isSetUp = !1, this.handleRefCountChange = function () {
          var t = e.store.getState().refCount > 0;
          e.backend && (t && !e.isSetUp ? (e.backend.setup(), e.isSetUp = !0) : !t && e.isSetUp && (e.backend.teardown(), e.isSetUp = !1));
        };
        var r = function makeStoreInstance(e) {
          var t = "undefined" !== typeof window && window.__REDUX_DEVTOOLS_EXTENSION__;
          return Object(o.createStore)(reducers_reduce, e && t && t({
            name: "dnd-core",
            instanceId: "dnd-core"
          }));
        }(t);
        this.store = r, this.monitor = new A(r, new j(r)), r.subscribe(this.handleRefCountChange);
      }
      return function DragDropManagerImpl_createClass(e, t, r) {
        return t && DragDropManagerImpl_defineProperties(e.prototype, t), r && DragDropManagerImpl_defineProperties(e, r), e;
      }(DragDropManagerImpl, [{
        key: "receiveBackend",
        value: function receiveBackend(e) {
          this.backend = e;
        }
      }, {
        key: "getMonitor",
        value: function getMonitor() {
          return this.monitor;
        }
      }, {
        key: "getBackend",
        value: function getBackend() {
          return this.backend;
        }
      }, {
        key: "getRegistry",
        value: function getRegistry() {
          return this.monitor.registry;
        }
      }, {
        key: "getActions",
        value: function getActions() {
          var e = this,
            t = this.store.dispatch;
          var r = function createDragDropActions(e) {
            return {
              beginDrag: createBeginDrag(e),
              publishDragSource: createPublishDragSource(e),
              hover: createHover(e),
              drop: createDrop(e),
              endDrag: createEndDrag(e)
            };
          }(this);
          return Object.keys(r).reduce(function (n, o) {
            var i = r[o];
            return n[o] = function bindActionCreator(r) {
              return function () {
                for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
                  o[i] = arguments[i];
                }
                var a = r.apply(e, o);
                "undefined" !== typeof a && t(a);
              };
            }(i), n;
          }, {});
        }
      }, {
        key: "dispatch",
        value: function dispatch(e) {
          this.store.dispatch(e);
        }
      }]), DragDropManagerImpl;
    }();
    function createDragDropManager(e, t, r, n) {
      var o = new k(n),
        i = e(o, t, r);
      return o.receiveBackend(i), o;
    }
    r.d(t, "a", function () {
      return x;
    }), r.d(t, "b", function () {
      return createDndContext;
    });
    var x = n.createContext({
      dragDropManager: void 0
    });
    function createDndContext(e, t, r, n) {
      return {
        dragDropManager: createDragDropManager(e, t, r, n)
      };
    }
  },, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var r = function cssWithMappingToString(e, t) {
            var r = e[1] || "",
              n = e[3];
            if (!n) return r;
            if (t && "function" === typeof btoa) {
              var o = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(n),
                i = n.sources.map(function (e) {
                  return "/*# sourceURL=" + n.sourceRoot + e + " */";
                });
              return [r].concat(i).concat([o]).join("\n");
            }
            return [r].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
        }).join("");
      }, t.i = function (e, r) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var n = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          null != i && (n[i] = !0);
        }
        for (o = 0; o < e.length; o++) {
          var a = e[o];
          null != a[0] && n[a[0]] || (r && !a[2] ? a[2] = r : r && (a[2] = "(" + a[2] + ") and (" + r + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = {},
      o = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
      i = function getTarget() {
        var e = {};
        return function memorize(t) {
          if ("undefined" === typeof e[t]) {
            var r = document.querySelector(t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[t] = r;
          }
          return e[t];
        };
      }();
    function listToStyles(e, t) {
      for (var r = [], n = {}, o = 0; o < e.length; o++) {
        var i = e[o],
          a = t.base ? i[0] + t.base : i[0],
          c = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
        n[a] ? n[a].parts.push(c) : r.push(n[a] = {
          id: a,
          parts: [c]
        });
      }
      return r;
    }
    function addStylesToDom(e, t) {
      for (var r = 0; r < e.length; r++) {
        var o = e[r],
          i = n[o.id],
          a = 0;
        if (i) {
          for (i.refs++; a < i.parts.length; a++) {
            i.parts[a](o.parts[a]);
          }
          for (; a < o.parts.length; a++) {
            i.parts.push(addStyle(o.parts[a], t));
          }
        } else {
          for (var c = []; a < o.parts.length; a++) {
            c.push(addStyle(o.parts[a], t));
          }
          n[o.id] = {
            id: o.id,
            refs: 1,
            parts: c
          };
        }
      }
    }
    function insertStyleElement(e) {
      var t = document.createElement("style");
      if ("undefined" === typeof e.attributes.nonce) {
        var n = r.nc;
        n && (e.attributes.nonce = n);
      }
      if (Object.keys(e.attributes).forEach(function (r) {
        t.setAttribute(r, e.attributes[r]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var o = i(e.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(t);
      }
      return t;
    }
    var a = function replaceText() {
      var e = [];
      return function replace(t, r) {
        return e[t] = r, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, t, r, n) {
      var o = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = a(t, o);else {
        var i = document.createTextNode(o),
          c = e.childNodes;
        c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(i, c[t]) : e.appendChild(i);
      }
    }
    var c = null,
      u = 0;
    function addStyle(e, t) {
      var r, n, o;
      if (t.singleton) {
        var i = u++;
        r = c || (c = insertStyleElement(t)), n = applyToSingletonTag.bind(null, r, i, !1), o = applyToSingletonTag.bind(null, r, i, !0);
      } else r = insertStyleElement(t), n = function applyToTag(e, t, r) {
        var n = r.css,
          o = r.media,
          i = r.sourceMap;
        if (o && e.setAttribute("media", o), i && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, r, t), o = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(r);
      };
      return n(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else o();
      };
    }
    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = o());
      var r = listToStyles(e, t);
      return addStylesToDom(r, t), function update(e) {
        for (var o = [], i = 0; i < r.length; i++) {
          var a = r[i],
            c = n[a.id];
          c && (c.refs--, o.push(c));
        }
        e && addStylesToDom(listToStyles(e, t), t);
        for (var u = 0; u < o.length; u++) {
          var s = o[u];
          if (0 === s.refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }
            delete n[s.id];
          }
        }
      };
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      function rawAsap(e) {
        o.length || (n(), !0), o[o.length] = e;
      }
      r.d(t, "a", function () {
        return rawAsap;
      });
      var n,
        o = [],
        i = 0,
        a = 1024;
      function flush() {
        for (; i < o.length;) {
          var e = i;
          if (i += 1, o[e].call(), i > a) {
            for (var t = 0, r = o.length - i; t < r; t++) {
              o[t] = o[t + i];
            }
            o.length -= i, i = 0;
          }
        }
        o.length = 0, i = 0, !1;
      }
      var c = "undefined" !== typeof e ? e : self,
        u = c.MutationObserver || c.WebKitMutationObserver;
      function makeRequestCallFromTimer(e) {
        return function requestCall() {
          var t = setTimeout(handleTimer, 0),
            r = setInterval(handleTimer, 50);
          function handleTimer() {
            clearTimeout(t), clearInterval(r), e();
          }
        };
      }
      n = "function" === typeof u ? function makeRequestCallFromMutationObserver(e) {
        var t = 1,
          r = new u(e),
          n = document.createTextNode("");
        return r.observe(n, {
          characterData: !0
        }), function requestCall() {
          t = -t, n.data = t;
        };
      }(flush) : makeRequestCallFromTimer(flush), rawAsap.requestFlush = n, rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
    }).call(this, r(18));
  }, function (e, t, r) {
    e.exports = r(38);
  },,, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || new Function("return this")();
    } catch (n) {
      "object" === typeof window && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    var n = r(6).compose;
    t.__esModule = !0, t.composeWithDevTools = "undefined" !== typeof window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
      if (0 !== arguments.length) return "object" === typeof arguments[0] ? n : n.apply(null, arguments);
    }, t.devToolsEnhancer = "undefined" !== typeof window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
      return function (e) {
        return e;
      };
    };
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.faChartColumn = void 0;
    t.faChartColumn = {
      prefix: "fal",
      iconName: "faChartColumn",
      icon: [512, 512, [], "", "M496 448h-416C53.53 448 32 426.5 32 400v-352C32 39.16 24.84 32 16 32S0 39.16 0 48v352C0 444.1 35.88 480 80 480h416c8.844 0 16-7.156 16-16S504.8 448 496 448zM159.1 368C168.8 368 176 360.8 176 352V256c0-8.844-7.156-16-16-16S143.1 247.2 143.1 256L144 352C144 360.8 151.1 368 159.1 368zM255.1 368C264.8 368 272 360.8 272 352V128c0-8.844-7.156-16-16-16S239.1 119.2 239.1 128L240 352C240 360.8 247.1 368 255.1 368zM351.1 368C360.8 368 368 360.8 368 352V192c0-8.844-7.156-16-16-16S335.1 183.2 335.1 192L336 352C336 360.8 343.1 368 351.1 368zM447.1 368C456.8 368 464 360.8 464 352V96c0-8.844-7.156-16-16-16S431.1 87.16 431.1 96L432 352C432 360.8 439.1 368 447.1 368z"]
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.faChartPieSimple = void 0;
    t.faChartPieSimple = {
      prefix: "fal",
      iconName: "faChartPieSimple",
      icon: [512, 512, [], "", "M464 256H256V48C256 39.16 248.8 32 240 32C107.7 32 0 139.7 0 272S107.6 512 239.1 512S480 404.3 480 272C480 263.2 472.8 256 464 256zM240 480C125.3 480 32 386.7 32 272c0-109.3 84.75-199.2 192-207.4V272C224 280.8 231.2 288 240 288h207.4C439.2 395.3 349.3 480 240 480zM304 0c-8.844 0-15.9 7.17-15.9 16.01L288 208C288 216.8 295.2 224 304 224l191.9 .0061C504.7 224 512 216.8 512 208C512 93.31 418.7 0 304 0zM320 192V32.72C404.3 40.34 471.7 107.7 479.3 192H320z"]
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.faMagnifyingGlass = void 0;
    t.faMagnifyingGlass = {
      prefix: "fal",
      iconName: "faMagnifyingGlass",
      icon: [512, 512, [], "", "M507.3 484.7l-141.5-141.5C397 306.8 415.1 259.7 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5C487.8 510.4 491.9 512 496 512s8.188-1.562 11.31-4.688C513.6 501.1 513.6 490.9 507.3 484.7zM208 384C110.1 384 32 305 32 208S110.1 32 208 32S384 110.1 384 208S305 384 208 384z"]
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.faPhone = void 0;
    t.faPhone = {
      prefix: "fal",
      iconName: "faPhone",
      icon: [512, 512, [], "", "M484.6 330.6C484.6 330.6 484.6 330.6 484.6 330.6l-101.8-43.66c-18.5-7.688-40.2-2.375-52.75 13.08l-33.14 40.47C244.2 311.8 200.3 267.9 171.6 215.2l40.52-33.19c15.67-12.92 20.83-34.16 12.84-52.84L181.4 27.37C172.7 7.279 150.8-3.737 129.6 1.154L35.17 23.06C14.47 27.78 0 45.9 0 67.12C0 312.4 199.6 512 444.9 512c21.23 0 39.41-14.44 44.17-35.13l21.8-94.47C515.7 361.1 504.7 339.3 484.6 330.6zM457.9 469.7c-1.375 5.969-6.844 10.31-12.98 10.31c-227.7 0-412.9-185.2-412.9-412.9c0-6.188 4.234-11.48 10.34-12.88l94.41-21.91c1-.2344 2-.3438 2.984-.3438c5.234 0 10.11 3.094 12.25 8.031l43.58 101.7C197.9 147.2 196.4 153.5 191.8 157.3L141.3 198.7C135.6 203.4 133.8 211.4 137.1 218.1c33.38 67.81 89.11 123.5 156.9 156.9c6.641 3.313 14.73 1.531 19.44-4.219l41.39-50.5c3.703-4.563 10.16-6.063 15.5-3.844l101.6 43.56c5.906 2.563 9.156 8.969 7.719 15.22L457.9 469.7z"]
    };
  },,,, function (e, t, r) {
    e.exports = r(39);
  }, function (e, t, r) {
    var n = r(31);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(13)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(12)(!0)).push([e.i, ".onboarding-dnd-container-title {\n  margin: 0 0 8px 0;\n}\n\n.onboarding-dnd-item {\n  align-items: center;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 4px;\n  color: var(--color-p1-8);\n  cursor: -webkit-grab;\n  cursor: grab;\n  display: flex;\n  justify-content: space-between;\n  padding: 4px;\n}\n\n.onboarding-dnd-item.onboarding-dnd-item--empty {\n  color: var(--color-p1-5);\n  cursor: default;\n  padding: 10px 4px 10px 6px;\n}\n\n.onboarding-dnd-item + .onboarding-dnd-item {\n  margin-top: 8px;\n}\n\n.onboarding-dnd-item-content {\n  align-items: center;\n  display: flex;\n}\n\n.onboarding-dnd-item-handle {\n  margin-right: 8px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,oBAAY;EAAZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB",
      file: "styles.css",
      sourcesContent: [".onboarding-dnd-container-title {\n  margin: 0 0 8px 0;\n}\n\n.onboarding-dnd-item {\n  align-items: center;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 4px;\n  color: var(--color-p1-8);\n  cursor: grab;\n  display: flex;\n  justify-content: space-between;\n  padding: 4px;\n}\n\n.onboarding-dnd-item.onboarding-dnd-item--empty {\n  color: var(--color-p1-5);\n  cursor: default;\n  padding: 10px 4px 10px 6px;\n}\n\n.onboarding-dnd-item + .onboarding-dnd-item {\n  margin-top: 8px;\n}\n\n.onboarding-dnd-item-content {\n  align-items: center;\n  display: flex;\n}\n\n.onboarding-dnd-item-handle {\n  margin-right: 8px;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(33);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(13)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(12)(!0)).push([e.i, "/* Filter Buttons */\n\n.onboarding-goal-selection-filters {\n  margin-top: 40px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip {\n  display: inline-block;\n  margin-top: 2px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip\n  + .onboarding-goal-selection-filter-button-tooltip {\n  margin-left: 8px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip-content {\n  text-transform: lowercase;\n}\n\n.onboarding-goal-selection-filter-button-tooltip-content::first-letter {\n  text-transform: capitalize;\n}\n\n.onboarding-goal-selection-filter-button {\n  border: 1px solid var(--color-p3-4);\n  border-radius: 100px;\n  color: var(--color-p1-10);\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  padding: 8px 16px;\n  text-transform: lowercase;\n}\n\n.onboarding-goal-selection-filter-button::first-letter {\n  text-transform: capitalize;\n}\n\n.onboarding-goal-selection-filter-button:hover {\n  background-color: var(--color-p3-2);\n  border-color: var(--color-p3-5);\n}\n\n.onboarding-goal-selection-filter-button.onboarding-goal-selection-filter-button--active {\n  background-color: var(--color-p3-2);\n}\n\n/* Cards */\n\n.onboarding-goal-selection-card-container {\n  grid-column-gap: 12px;\n  -webkit-column-gap: 12px;\n          column-gap: 12px;\n  display: grid;\n  grid-auto-rows: 140px;\n  grid-template-columns: repeat(auto-fit, minmax(248px, 1fr));\n  margin-top: 12px;\n  grid-row-gap: 12px;\n  row-gap: 12px;\n}\n\n.oc.onboarding-goal-selection-card {\n  border-color: var(--color-p3-4);\n  cursor: pointer;\n  margin: 0;\n  overflow: hidden;\n  padding: 15px;\n}\n\n.oc.onboarding-goal-selection-card:not(.onboarding-goal-selection-card--selected):not(.onboarding-goal-selection-card--disabled):hover {\n  border-color: var(--color-p3-5);\n}\n\n.oc.onboarding-goal-selection-card--selected {\n  background: var(--color-p3-2);\n  border-color: var(--color-p3-6);\n}\n\n.oc.onboarding-goal-selection-card--disabled {\n  background: var(--color-p1-3);\n  border-color: var(--color-p1-5);\n  cursor: default;\n}\n\n.oc.onboarding-goal-selection-card--disabled .oc.checkbox {\n  cursor: default;\n}\n\n.onboarding-goal-selection-card-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.onboarding-goal-selection-card-label {\n  color: var(--color-p1-5-5);\n  grid-column-gap: 8px;\n  -webkit-column-gap: 8px;\n          column-gap: 8px;\n  display: grid;\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-subtle);\n  grid-template-columns: auto auto;\n  transition: var(--transition-catchall-simple);\n}\n\n.onboarding-goal-selection-card-goal-title {\n  padding-right: 18px;\n  transition: var(--transition-catchall-simple);\n}\n\n.onboarding-goal-selection-card-goal-description {\n  opacity: 0;\n  transition: var(--transition-catchall-simple);\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA,mBAAmB;;AAEnB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,8CAA8C;EAC9C,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,UAAU;;AAEV;EACE,qBAAgB;EAAhB,wBAAgB;UAAhB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAa;EAAb,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,oBAAe;EAAf,uBAAe;UAAf,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C,kCAAkC;EAClC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,6CAA6C;AAC/C",
      file: "styles.css",
      sourcesContent: ["/* Filter Buttons */\n\n.onboarding-goal-selection-filters {\n  margin-top: 40px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip {\n  display: inline-block;\n  margin-top: 2px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip\n  + .onboarding-goal-selection-filter-button-tooltip {\n  margin-left: 8px;\n}\n\n.onboarding-goal-selection-filter-button-tooltip-content {\n  text-transform: lowercase;\n}\n\n.onboarding-goal-selection-filter-button-tooltip-content::first-letter {\n  text-transform: capitalize;\n}\n\n.onboarding-goal-selection-filter-button {\n  border: 1px solid var(--color-p3-4);\n  border-radius: 100px;\n  color: var(--color-p1-10);\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  padding: 8px 16px;\n  text-transform: lowercase;\n}\n\n.onboarding-goal-selection-filter-button::first-letter {\n  text-transform: capitalize;\n}\n\n.onboarding-goal-selection-filter-button:hover {\n  background-color: var(--color-p3-2);\n  border-color: var(--color-p3-5);\n}\n\n.onboarding-goal-selection-filter-button.onboarding-goal-selection-filter-button--active {\n  background-color: var(--color-p3-2);\n}\n\n/* Cards */\n\n.onboarding-goal-selection-card-container {\n  column-gap: 12px;\n  display: grid;\n  grid-auto-rows: 140px;\n  grid-template-columns: repeat(auto-fit, minmax(248px, 1fr));\n  margin-top: 12px;\n  row-gap: 12px;\n}\n\n.oc.onboarding-goal-selection-card {\n  border-color: var(--color-p3-4);\n  cursor: pointer;\n  margin: 0;\n  overflow: hidden;\n  padding: 15px;\n}\n\n.oc.onboarding-goal-selection-card:not(.onboarding-goal-selection-card--selected):not(.onboarding-goal-selection-card--disabled):hover {\n  border-color: var(--color-p3-5);\n}\n\n.oc.onboarding-goal-selection-card--selected {\n  background: var(--color-p3-2);\n  border-color: var(--color-p3-6);\n}\n\n.oc.onboarding-goal-selection-card--disabled {\n  background: var(--color-p1-3);\n  border-color: var(--color-p1-5);\n  cursor: default;\n}\n\n.oc.onboarding-goal-selection-card--disabled .oc.checkbox {\n  cursor: default;\n}\n\n.onboarding-goal-selection-card-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.onboarding-goal-selection-card-label {\n  color: var(--color-p1-5-5);\n  column-gap: 8px;\n  display: grid;\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-subtle);\n  grid-template-columns: auto auto;\n  transition: var(--transition-catchall-simple);\n}\n\n.onboarding-goal-selection-card-goal-title {\n  padding-right: 18px;\n  transition: var(--transition-catchall-simple);\n}\n\n.onboarding-goal-selection-card-goal-description {\n  opacity: 0;\n  transition: var(--transition-catchall-simple);\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(35);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(13)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(12)(!0)).push([e.i, ".oc-modal-goal-dnd {\n  margin-top: 132px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,iBAAiB;AACnB",
      file: "styles.css",
      sourcesContent: [".oc-modal-goal-dnd {\n  margin-top: 132px;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = r(37);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    };
    r(13)(n, o);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    (e.exports = r(12)(!0)).push([e.i, ".oc.goal-preview-card {\n  align-items: center;\n  border: 1px solid var(--color-p1-5);\n  border-top: 4px solid var(--color-p3-10);\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  color: var(--color-p1-10);\n  grid-column-gap: 12px;\n  -webkit-column-gap: 12px;\n          column-gap: 12px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n}\n\n.oc.goal-preview-card.goal-preview-card--loading {\n  grid-template-columns: 564px;\n}\n\n.oc.target-icon {\n  background-size: 100%;\n  height: 40px;\n  width: 40px;\n}\n\n.goal-preview-card-goals {\n  text-transform: lowercase;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAgB;EAAhB,wBAAgB;UAAhB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B",
      file: "styles.css",
      sourcesContent: [".oc.goal-preview-card {\n  align-items: center;\n  border: 1px solid var(--color-p1-5);\n  border-top: 4px solid var(--color-p3-10);\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  color: var(--color-p1-10);\n  column-gap: 12px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n}\n\n.oc.goal-preview-card.goal-preview-card--loading {\n  grid-template-columns: 564px;\n}\n\n.oc.target-icon {\n  background-size: 100%;\n  height: 40px;\n  width: 40px;\n}\n\n.goal-preview-card-goals {\n  text-transform: lowercase;\n}\n"]
    }]);
  }, function (e, t, r) {
    var n = function (e) {
      "use strict";

      var t,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" === typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";
      function wrap(e, t, r, n) {
        var o = t && t.prototype instanceof Generator ? t : Generator,
          i = Object.create(o.prototype),
          a = new Context(n || []);
        return i._invoke = function makeInvokeMethod(e, t, r) {
          var n = u;
          return function invoke(o, i) {
            if (n === l) throw new Error("Generator is already running");
            if (n === d) {
              if ("throw" === o) throw i;
              return doneResult();
            }
            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;
              if (a) {
                var c = maybeInvokeDelegate(a, r);
                if (c) {
                  if (c === f) continue;
                  return c;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === u) throw n = d, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = l;
              var p = tryCatch(e, t, r);
              if ("normal" === p.type) {
                if (n = r.done ? d : s, p.arg === f) continue;
                return {
                  value: p.arg,
                  done: r.done
                };
              }
              "throw" === p.type && (n = d, r.method = "throw", r.arg = p.arg);
            }
          };
        }(e, r, a), i;
      }
      function tryCatch(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (n) {
          return {
            type: "throw",
            arg: n
          };
        }
      }
      e.wrap = wrap;
      var u = "suspendedStart",
        s = "suspendedYield",
        l = "executing",
        d = "completed",
        f = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var p = {};
      p[i] = function () {
        return this;
      };
      var h = Object.getPrototypeOf,
        g = h && h(h(values([])));
      g && g !== r && n.call(g, i) && (p = g);
      var b = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }
      function AsyncIterator(e, t) {
        var r;
        this._invoke = function enqueue(o, i) {
          function callInvokeWithMethodAndArg() {
            return new t(function (r, a) {
              !function invoke(r, o, i, a) {
                var c = tryCatch(e[r], e, o);
                if ("throw" !== c.type) {
                  var u = c.arg,
                    s = u.value;
                  return s && "object" === typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
                    invoke("next", e, i, a);
                  }, function (e) {
                    invoke("throw", e, i, a);
                  }) : t.resolve(s).then(function (e) {
                    u.value = e, i(u);
                  }, function (e) {
                    return invoke("throw", e, i, a);
                  });
                }
                a(c.arg);
              }(o, i, r, a);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }
      function maybeInvokeDelegate(e, r) {
        var n = e.iterator[r.method];
        if (n === t) {
          if (r.delegate = null, "throw" === r.method) {
            if (e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method)) return f;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return f;
        }
        var o = tryCatch(n, e.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, f;
        var i = o.arg;
        return i ? i.done ? (r[e.resultName] = i.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, f) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, f);
      }
      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(e) {
        if (e) {
          var r = e[i];
          if (r) return r.call(e);
          if ("function" === typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              a = function next() {
                for (; ++o < e.length;) {
                  if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                }
                return next.value = t, next.done = !0, next;
              };
            return a.next = a;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }
      return GeneratorFunction.prototype = b.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[c] = GeneratorFunction.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, c in e || (e[c] = "GeneratorFunction")), e.prototype = Object.create(b), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[a] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, defineIteratorMethods(b), b[c] = "Generator", b[i] = function () {
        return this;
      }, b.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var r in e) {
          t.push(r);
        }
        return t.reverse(), function next() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return next.value = r, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;
          function handle(n, o) {
            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return handle("end");
            if (i.tryLoc <= this.prev) {
              var c = n.call(i, "catchLoc"),
                u = n.call(i, "finallyLoc");
              if (c && u) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), f;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), f;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.tryLoc === e) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                resetTryEntry(r);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), f;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = n;
    } catch (o) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (n, o, i) {
    "use strict";

    i.r(o);
    var a = {};
    i.r(a), i.d(a, "initialize", function () {
      return rt;
    }), i.d(a, "fetchOrgGoals", function () {
      return nt;
    }), i.d(a, "fetchOrgGoalsSuccess", function () {
      return ot;
    }), i.d(a, "fetchOrgGoalsPending", function () {
      return it;
    }), i.d(a, "fetchOrgGoalsFailed", function () {
      return at;
    }), i.d(a, "saveOrgGoals", function () {
      return ct;
    }), i.d(a, "saveOrgGoalsSuccess", function () {
      return ut;
    }), i.d(a, "saveOrgGoalsPending", function () {
      return st;
    }), i.d(a, "saveOrgGoalsFailed", function () {
      return lt;
    }), i.d(a, "updateOrgGoals", function () {
      return dt;
    });
    var y = {};
    i.r(y), i.d(y, "getOrgGoals", function () {
      return At;
    }), i.d(y, "getExistingGoals", function () {
      return wt;
    }), i.d(y, "getFetchOrgGoalsStatus", function () {
      return Et;
    }), i.d(y, "getFetchOrgGoalsLoading", function () {
      return Ct;
    }), i.d(y, "getSaveOrgGoalsStatus", function () {
      return Tt;
    }), i.d(y, "getSaveOrgGoalsLoading", function () {
      return Dt;
    });
    var m = {};
    i.r(m), i.d(m, "FILE", function () {
      return Wr;
    }), i.d(m, "URL", function () {
      return Vr;
    }), i.d(m, "TEXT", function () {
      return Kr;
    });
    var C = i(0),
      T = i.n(C),
      x = i(6),
      L = i(8),
      B = function extendStatics(e, t) {
        return (B = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        })(e, t);
      };
    function __extends(e, t) {
      function __() {
        this.constructor = e;
      }
      B(e, t), e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    }
    var G = function () {
      return Array.isArray || function (e) {
        return e && "number" === typeof e.length;
      };
    }();
    function isObject(e) {
      return null !== e && "object" === typeof e;
    }
    function isFunction(e) {
      return "function" === typeof e;
    }
    var H = function () {
        function UnsubscriptionErrorImpl(e) {
          return Error.call(this), this.message = e ? e.length + " errors occurred during unsubscription:\n" + e.map(function (e, t) {
            return t + 1 + ") " + e.toString();
          }).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = e, this;
        }
        return UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype), UnsubscriptionErrorImpl;
      }(),
      F = function () {
        function Subscription(e) {
          this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._ctorUnsubscribe = !0, this._unsubscribe = e);
        }
        var e;
        return Subscription.prototype.unsubscribe = function () {
          var e;
          if (!this.closed) {
            var t = this._parentOrParents,
              r = this._ctorUnsubscribe,
              n = this._unsubscribe,
              o = this._subscriptions;
            if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, t instanceof Subscription) t.remove(this);else if (null !== t) for (var i = 0; i < t.length; ++i) {
              t[i].remove(this);
            }
            if (isFunction(n)) {
              r && (this._unsubscribe = void 0);
              try {
                n.call(this);
              } catch (u) {
                e = u instanceof H ? flattenUnsubscriptionErrors(u.errors) : [u];
              }
            }
            if (G(o)) {
              i = -1;
              for (var a = o.length; ++i < a;) {
                var c = o[i];
                if (isObject(c)) try {
                  c.unsubscribe();
                } catch (u) {
                  e = e || [], u instanceof H ? e = e.concat(flattenUnsubscriptionErrors(u.errors)) : e.push(u);
                }
              }
            }
            if (e) throw new H(e);
          }
        }, Subscription.prototype.add = function (e) {
          var t = e;
          if (!e) return Subscription.EMPTY;
          switch (typeof e) {
            case "function":
              t = new Subscription(e);
            case "object":
              if (t === this || t.closed || "function" !== typeof t.unsubscribe) return t;
              if (this.closed) return t.unsubscribe(), t;
              if (!(t instanceof Subscription)) {
                var r = t;
                (t = new Subscription())._subscriptions = [r];
              }
              break;
            default:
              throw new Error("unrecognized teardown " + e + " added to Subscription.");
          }
          var n = t._parentOrParents;
          if (null === n) t._parentOrParents = this;else if (n instanceof Subscription) {
            if (n === this) return t;
            t._parentOrParents = [n, this];
          } else {
            if (-1 !== n.indexOf(this)) return t;
            n.push(this);
          }
          var o = this._subscriptions;
          return null === o ? this._subscriptions = [t] : o.push(t), t;
        }, Subscription.prototype.remove = function (e) {
          var t = this._subscriptions;
          if (t) {
            var r = t.indexOf(e);
            -1 !== r && t.splice(r, 1);
          }
        }, Subscription.EMPTY = ((e = new Subscription()).closed = !0, e), Subscription;
      }();
    function flattenUnsubscriptionErrors(e) {
      return e.reduce(function (e, t) {
        return e.concat(t instanceof H ? t.errors : t);
      }, []);
    }
    var U = function (e) {
        function AsyncAction(t, r) {
          var n = e.call(this, t, r) || this;
          return n.scheduler = t, n.work = r, n.pending = !1, n;
        }
        return __extends(AsyncAction, e), AsyncAction.prototype.schedule = function (e, t) {
          if (void 0 === t && (t = 0), this.closed) return this;
          this.state = e;
          var r = this.id,
            n = this.scheduler;
          return null != r && (this.id = this.recycleAsyncId(n, r, t)), this.pending = !0, this.delay = t, this.id = this.id || this.requestAsyncId(n, this.id, t), this;
        }, AsyncAction.prototype.requestAsyncId = function (e, t, r) {
          return void 0 === r && (r = 0), setInterval(e.flush.bind(e, this), r);
        }, AsyncAction.prototype.recycleAsyncId = function (e, t, r) {
          if (void 0 === r && (r = 0), null !== r && this.delay === r && !1 === this.pending) return t;
          clearInterval(t);
        }, AsyncAction.prototype.execute = function (e, t) {
          if (this.closed) return new Error("executing a cancelled action");
          this.pending = !1;
          var r = this._execute(e, t);
          if (r) return r;
          !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
        }, AsyncAction.prototype._execute = function (e, t) {
          var r = !1,
            n = void 0;
          try {
            this.work(e);
          } catch (o) {
            r = !0, n = !!o && o || new Error(o);
          }
          if (r) return this.unsubscribe(), n;
        }, AsyncAction.prototype._unsubscribe = function () {
          var e = this.id,
            t = this.scheduler,
            r = t.actions,
            n = r.indexOf(this);
          this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== n && r.splice(n, 1), null != e && (this.id = this.recycleAsyncId(t, e, null)), this.delay = null;
        }, AsyncAction;
      }(function (e) {
        function Action(t, r) {
          return e.call(this) || this;
        }
        return __extends(Action, e), Action.prototype.schedule = function (e, t) {
          return void 0 === t && (t = 0), this;
        }, Action;
      }(F)),
      q = function (e) {
        function QueueAction(t, r) {
          var n = e.call(this, t, r) || this;
          return n.scheduler = t, n.work = r, n;
        }
        return __extends(QueueAction, e), QueueAction.prototype.schedule = function (t, r) {
          return void 0 === r && (r = 0), r > 0 ? e.prototype.schedule.call(this, t, r) : (this.delay = r, this.state = t, this.scheduler.flush(this), this);
        }, QueueAction.prototype.execute = function (t, r) {
          return r > 0 || this.closed ? e.prototype.execute.call(this, t, r) : this._execute(t, r);
        }, QueueAction.prototype.requestAsyncId = function (t, r, n) {
          return void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0 ? e.prototype.requestAsyncId.call(this, t, r, n) : t.flush(this);
        }, QueueAction;
      }(U),
      W = function () {
        function Scheduler(e, t) {
          void 0 === t && (t = Scheduler.now), this.SchedulerAction = e, this.now = t;
        }
        return Scheduler.prototype.schedule = function (e, t, r) {
          return void 0 === t && (t = 0), new this.SchedulerAction(this, e).schedule(r, t);
        }, Scheduler.now = function () {
          return Date.now();
        }, Scheduler;
      }(),
      V = function (e) {
        function AsyncScheduler(t, r) {
          void 0 === r && (r = W.now);
          var n = e.call(this, t, function () {
            return AsyncScheduler.delegate && AsyncScheduler.delegate !== n ? AsyncScheduler.delegate.now() : r();
          }) || this;
          return n.actions = [], n.active = !1, n.scheduled = void 0, n;
        }
        return __extends(AsyncScheduler, e), AsyncScheduler.prototype.schedule = function (t, r, n) {
          return void 0 === r && (r = 0), AsyncScheduler.delegate && AsyncScheduler.delegate !== this ? AsyncScheduler.delegate.schedule(t, r, n) : e.prototype.schedule.call(this, t, r, n);
        }, AsyncScheduler.prototype.flush = function (e) {
          var t = this.actions;
          if (this.active) t.push(e);else {
            var r;
            this.active = !0;
            do {
              if (r = e.execute(e.state, e.delay)) break;
            } while (e = t.shift());
            if (this.active = !1, r) {
              for (; e = t.shift();) {
                e.unsubscribe();
              }
              throw r;
            }
          }
        }, AsyncScheduler;
      }(W),
      K = new (function (e) {
        function QueueScheduler() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return __extends(QueueScheduler, e), QueueScheduler;
      }(V))(q),
      Y = !1,
      J = {
        Promise: void 0,
        set useDeprecatedSynchronousErrorHandling(e) {
          e && new Error().stack;
          Y = e;
        },
        get useDeprecatedSynchronousErrorHandling() {
          return Y;
        }
      };
    function hostReportError(e) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
    var X = {
        closed: !0,
        next: function next(e) {},
        error: function error(e) {
          if (J.useDeprecatedSynchronousErrorHandling) throw e;
          hostReportError(e);
        },
        complete: function complete() {}
      },
      $ = function () {
        return "function" === typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
      }(),
      Q = function (e) {
        function Subscriber(t, r, n) {
          var o = e.call(this) || this;
          switch (o.syncErrorValue = null, o.syncErrorThrown = !1, o.syncErrorThrowable = !1, o.isStopped = !1, arguments.length) {
            case 0:
              o.destination = X;
              break;
            case 1:
              if (!t) {
                o.destination = X;
                break;
              }
              if ("object" === typeof t) {
                t instanceof Subscriber ? (o.syncErrorThrowable = t.syncErrorThrowable, o.destination = t, t.add(o)) : (o.syncErrorThrowable = !0, o.destination = new Z(o, t));
                break;
              }
            default:
              o.syncErrorThrowable = !0, o.destination = new Z(o, t, r, n);
          }
          return o;
        }
        return __extends(Subscriber, e), Subscriber.prototype[$] = function () {
          return this;
        }, Subscriber.create = function (e, t, r) {
          var n = new Subscriber(e, t, r);
          return n.syncErrorThrowable = !1, n;
        }, Subscriber.prototype.next = function (e) {
          this.isStopped || this._next(e);
        }, Subscriber.prototype.error = function (e) {
          this.isStopped || (this.isStopped = !0, this._error(e));
        }, Subscriber.prototype.complete = function () {
          this.isStopped || (this.isStopped = !0, this._complete());
        }, Subscriber.prototype.unsubscribe = function () {
          this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
        }, Subscriber.prototype._next = function (e) {
          this.destination.next(e);
        }, Subscriber.prototype._error = function (e) {
          this.destination.error(e), this.unsubscribe();
        }, Subscriber.prototype._complete = function () {
          this.destination.complete(), this.unsubscribe();
        }, Subscriber.prototype._unsubscribeAndRecycle = function () {
          var e = this._parentOrParents;
          return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = e, this;
        }, Subscriber;
      }(F),
      Z = function (e) {
        function SafeSubscriber(t, r, n, o) {
          var i,
            a = e.call(this) || this;
          a._parentSubscriber = t;
          var c = a;
          return isFunction(r) ? i = r : r && (i = r.next, n = r.error, o = r.complete, r !== X && (isFunction((c = Object.create(r)).unsubscribe) && a.add(c.unsubscribe.bind(c)), c.unsubscribe = a.unsubscribe.bind(a))), a._context = c, a._next = i, a._error = n, a._complete = o, a;
        }
        return __extends(SafeSubscriber, e), SafeSubscriber.prototype.next = function (e) {
          if (!this.isStopped && this._next) {
            var t = this._parentSubscriber;
            J.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe() : this.__tryOrUnsub(this._next, e);
          }
        }, SafeSubscriber.prototype.error = function (e) {
          if (!this.isStopped) {
            var t = this._parentSubscriber,
              r = J.useDeprecatedSynchronousErrorHandling;
            if (this._error) r && t.syncErrorThrowable ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe()) : (this.__tryOrUnsub(this._error, e), this.unsubscribe());else if (t.syncErrorThrowable) r ? (t.syncErrorValue = e, t.syncErrorThrown = !0) : hostReportError(e), this.unsubscribe();else {
              if (this.unsubscribe(), r) throw e;
              hostReportError(e);
            }
          }
        }, SafeSubscriber.prototype.complete = function () {
          var e = this;
          if (!this.isStopped) {
            var t = this._parentSubscriber;
            if (this._complete) {
              var r = function wrappedComplete() {
                return e._complete.call(e._context);
              };
              J.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? (this.__tryOrSetError(t, r), this.unsubscribe()) : (this.__tryOrUnsub(r), this.unsubscribe());
            } else this.unsubscribe();
          }
        }, SafeSubscriber.prototype.__tryOrUnsub = function (e, t) {
          try {
            e.call(this._context, t);
          } catch (r) {
            if (this.unsubscribe(), J.useDeprecatedSynchronousErrorHandling) throw r;
            hostReportError(r);
          }
        }, SafeSubscriber.prototype.__tryOrSetError = function (e, t, r) {
          if (!J.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
          try {
            t.call(this._context, r);
          } catch (n) {
            return J.useDeprecatedSynchronousErrorHandling ? (e.syncErrorValue = n, e.syncErrorThrown = !0, !0) : (hostReportError(n), !0);
          }
          return !1;
        }, SafeSubscriber.prototype._unsubscribe = function () {
          var e = this._parentSubscriber;
          this._context = null, this._parentSubscriber = null, e.unsubscribe();
        }, SafeSubscriber;
      }(Q);
    var ee = function () {
      return "function" === typeof Symbol && Symbol.observable || "@@observable";
    }();
    function identity(e) {
      return e;
    }
    function pipeFromArray(e) {
      return 0 === e.length ? identity : 1 === e.length ? e[0] : function piped(t) {
        return e.reduce(function (e, t) {
          return t(e);
        }, t);
      };
    }
    var te = function () {
      function Observable(e) {
        this._isScalar = !1, e && (this._subscribe = e);
      }
      return Observable.prototype.lift = function (e) {
        var t = new Observable();
        return t.source = this, t.operator = e, t;
      }, Observable.prototype.subscribe = function (e, t, r) {
        var n = this.operator,
          o = function toSubscriber(e, t, r) {
            if (e) {
              if (e instanceof Q) return e;
              if (e[$]) return e[$]();
            }
            return e || t || r ? new Q(e, t, r) : new Q(X);
          }(e, t, r);
        if (n ? o.add(n.call(o, this.source)) : o.add(this.source || J.useDeprecatedSynchronousErrorHandling && !o.syncErrorThrowable ? this._subscribe(o) : this._trySubscribe(o)), J.useDeprecatedSynchronousErrorHandling && o.syncErrorThrowable && (o.syncErrorThrowable = !1, o.syncErrorThrown)) throw o.syncErrorValue;
        return o;
      }, Observable.prototype._trySubscribe = function (e) {
        try {
          return this._subscribe(e);
        } catch (t) {
          J.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = t), !function canReportError(e) {
            for (; e;) {
              var t = e,
                r = t.closed,
                n = t.destination,
                o = t.isStopped;
              if (r || o) return !1;
              e = n && n instanceof Q ? n : null;
            }
            return !0;
          }(e) ? console.warn(t) : e.error(t);
        }
      }, Observable.prototype.forEach = function (e, t) {
        var r = this;
        return new (t = getPromiseCtor(t))(function (t, n) {
          var o;
          o = r.subscribe(function (t) {
            try {
              e(t);
            } catch (r) {
              n(r), o && o.unsubscribe();
            }
          }, n, t);
        });
      }, Observable.prototype._subscribe = function (e) {
        var t = this.source;
        return t && t.subscribe(e);
      }, Observable.prototype[ee] = function () {
        return this;
      }, Observable.prototype.pipe = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }
        return 0 === e.length ? this : pipeFromArray(e)(this);
      }, Observable.prototype.toPromise = function (e) {
        var t = this;
        return new (e = getPromiseCtor(e))(function (e, r) {
          var n;
          t.subscribe(function (e) {
            return n = e;
          }, function (e) {
            return r(e);
          }, function () {
            return e(n);
          });
        });
      }, Observable.create = function (e) {
        return new Observable(e);
      }, Observable;
    }();
    function getPromiseCtor(e) {
      if (e || (e = J.Promise || Promise), !e) throw new Error("no Promise impl found");
      return e;
    }
    var re = function () {
        function ObjectUnsubscribedErrorImpl() {
          return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
        }
        return ObjectUnsubscribedErrorImpl.prototype = Object.create(Error.prototype), ObjectUnsubscribedErrorImpl;
      }(),
      ne = function (e) {
        function SubjectSubscription(t, r) {
          var n = e.call(this) || this;
          return n.subject = t, n.subscriber = r, n.closed = !1, n;
        }
        return __extends(SubjectSubscription, e), SubjectSubscription.prototype.unsubscribe = function () {
          if (!this.closed) {
            this.closed = !0;
            var e = this.subject,
              t = e.observers;
            if (this.subject = null, t && 0 !== t.length && !e.isStopped && !e.closed) {
              var r = t.indexOf(this.subscriber);
              -1 !== r && t.splice(r, 1);
            }
          }
        }, SubjectSubscription;
      }(F),
      oe = function (e) {
        function SubjectSubscriber(t) {
          var r = e.call(this, t) || this;
          return r.destination = t, r;
        }
        return __extends(SubjectSubscriber, e), SubjectSubscriber;
      }(Q),
      ie = function (e) {
        function Subject() {
          var t = e.call(this) || this;
          return t.observers = [], t.closed = !1, t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
        }
        return __extends(Subject, e), Subject.prototype[$] = function () {
          return new oe(this);
        }, Subject.prototype.lift = function (e) {
          var t = new ae(this, this);
          return t.operator = e, t;
        }, Subject.prototype.next = function (e) {
          if (this.closed) throw new re();
          if (!this.isStopped) for (var t = this.observers, r = t.length, n = t.slice(), o = 0; o < r; o++) {
            n[o].next(e);
          }
        }, Subject.prototype.error = function (e) {
          if (this.closed) throw new re();
          this.hasError = !0, this.thrownError = e, this.isStopped = !0;
          for (var t = this.observers, r = t.length, n = t.slice(), o = 0; o < r; o++) {
            n[o].error(e);
          }
          this.observers.length = 0;
        }, Subject.prototype.complete = function () {
          if (this.closed) throw new re();
          this.isStopped = !0;
          for (var e = this.observers, t = e.length, r = e.slice(), n = 0; n < t; n++) {
            r[n].complete();
          }
          this.observers.length = 0;
        }, Subject.prototype.unsubscribe = function () {
          this.isStopped = !0, this.closed = !0, this.observers = null;
        }, Subject.prototype._trySubscribe = function (t) {
          if (this.closed) throw new re();
          return e.prototype._trySubscribe.call(this, t);
        }, Subject.prototype._subscribe = function (e) {
          if (this.closed) throw new re();
          return this.hasError ? (e.error(this.thrownError), F.EMPTY) : this.isStopped ? (e.complete(), F.EMPTY) : (this.observers.push(e), new ne(this, e));
        }, Subject.prototype.asObservable = function () {
          var e = new te();
          return e.source = this, e;
        }, Subject.create = function (e, t) {
          return new ae(e, t);
        }, Subject;
      }(te),
      ae = function (e) {
        function AnonymousSubject(t, r) {
          var n = e.call(this) || this;
          return n.destination = t, n.source = r, n;
        }
        return __extends(AnonymousSubject, e), AnonymousSubject.prototype.next = function (e) {
          var t = this.destination;
          t && t.next && t.next(e);
        }, AnonymousSubject.prototype.error = function (e) {
          var t = this.destination;
          t && t.error && this.destination.error(e);
        }, AnonymousSubject.prototype.complete = function () {
          var e = this.destination;
          e && e.complete && this.destination.complete();
        }, AnonymousSubject.prototype._subscribe = function (e) {
          return this.source ? this.source.subscribe(e) : F.EMPTY;
        }, AnonymousSubject;
      }(ie),
      ce = function subscribeToArray(e) {
        return function (t) {
          for (var r = 0, n = e.length; r < n && !t.closed; r++) {
            t.next(e[r]);
          }
          t.complete();
        };
      };
    function getSymbolIterator() {
      return "function" === typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
    }
    var ue = getSymbolIterator(),
      se = function isArrayLike(e) {
        return e && "number" === typeof e.length && "function" !== typeof e;
      };
    function isPromise(e) {
      return !!e && "function" !== typeof e.subscribe && "function" === typeof e.then;
    }
    var le = function subscribeTo(e) {
      if (e && "function" === typeof e[ee]) return function subscribeToObservable(e) {
        return function (t) {
          var r = e[ee]();
          if ("function" !== typeof r.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
          return r.subscribe(t);
        };
      }(e);
      if (se(e)) return ce(e);
      if (isPromise(e)) return function subscribeToPromise(e) {
        return function (t) {
          return e.then(function (e) {
            t.closed || (t.next(e), t.complete());
          }, function (e) {
            return t.error(e);
          }).then(null, hostReportError), t;
        };
      }(e);
      if (e && "function" === typeof e[ue]) return function subscribeToIterable(e) {
        return function (t) {
          for (var r = e[ue]();;) {
            var n = void 0;
            try {
              n = r.next();
            } catch (o) {
              return t.error(o), t;
            }
            if (n.done) {
              t.complete();
              break;
            }
            if (t.next(n.value), t.closed) break;
          }
          return "function" === typeof r.return && t.add(function () {
            r.return && r.return();
          }), t;
        };
      }(e);
      var t = isObject(e) ? "an invalid object" : "'" + e + "'";
      throw new TypeError("You provided " + t + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.");
    };
    function scheduleArray(e, t) {
      return new te(function (r) {
        var n = new F(),
          o = 0;
        return n.add(t.schedule(function () {
          o !== e.length ? (r.next(e[o++]), r.closed || n.add(this.schedule())) : r.complete();
        })), n;
      });
    }
    function scheduled(e, t) {
      if (null != e) {
        if (function isInteropObservable(e) {
          return e && "function" === typeof e[ee];
        }(e)) return function scheduleObservable(e, t) {
          return new te(function (r) {
            var n = new F();
            return n.add(t.schedule(function () {
              var o = e[ee]();
              n.add(o.subscribe({
                next: function next(e) {
                  n.add(t.schedule(function () {
                    return r.next(e);
                  }));
                },
                error: function error(e) {
                  n.add(t.schedule(function () {
                    return r.error(e);
                  }));
                },
                complete: function complete() {
                  n.add(t.schedule(function () {
                    return r.complete();
                  }));
                }
              }));
            })), n;
          });
        }(e, t);
        if (isPromise(e)) return function schedulePromise(e, t) {
          return new te(function (r) {
            var n = new F();
            return n.add(t.schedule(function () {
              return e.then(function (e) {
                n.add(t.schedule(function () {
                  r.next(e), n.add(t.schedule(function () {
                    return r.complete();
                  }));
                }));
              }, function (e) {
                n.add(t.schedule(function () {
                  return r.error(e);
                }));
              });
            })), n;
          });
        }(e, t);
        if (se(e)) return scheduleArray(e, t);
        if (function isIterable(e) {
          return e && "function" === typeof e[ue];
        }(e) || "string" === typeof e) return function scheduleIterable(e, t) {
          if (!e) throw new Error("Iterable cannot be null");
          return new te(function (r) {
            var n,
              o = new F();
            return o.add(function () {
              n && "function" === typeof n.return && n.return();
            }), o.add(t.schedule(function () {
              n = e[ue](), o.add(t.schedule(function () {
                if (!r.closed) {
                  var e, t;
                  try {
                    var o = n.next();
                    e = o.value, t = o.done;
                  } catch (i) {
                    return void r.error(i);
                  }
                  t ? r.complete() : (r.next(e), this.schedule());
                }
              }));
            })), o;
          });
        }(e, t);
      }
      throw new TypeError((null !== e && typeof e || e) + " is not observable");
    }
    function from_from(e, t) {
      return t ? scheduled(e, t) : e instanceof te ? e : new te(le(e));
    }
    var de,
      fe = new te(function (e) {
        return e.complete();
      });
    function empty_empty(e) {
      return e ? function emptyScheduled(e) {
        return new te(function (t) {
          return e.schedule(function () {
            return t.complete();
          });
        });
      }(e) : fe;
    }
    function isScheduler(e) {
      return e && "function" === typeof e.schedule;
    }
    function fromArray(e, t) {
      return t ? scheduleArray(e, t) : new te(ce(e));
    }
    function of_of() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
      var r = e[e.length - 1];
      return isScheduler(r) ? (e.pop(), scheduleArray(e, r)) : fromArray(e);
    }
    function throwError_dispatch(e) {
      var t = e.error;
      e.subscriber.error(t);
    }
    de || (de = {});
    var pe = function () {
      function Notification(e, t, r) {
        this.kind = e, this.value = t, this.error = r, this.hasValue = "N" === e;
      }
      return Notification.prototype.observe = function (e) {
        switch (this.kind) {
          case "N":
            return e.next && e.next(this.value);
          case "E":
            return e.error && e.error(this.error);
          case "C":
            return e.complete && e.complete();
        }
      }, Notification.prototype.do = function (e, t, r) {
        switch (this.kind) {
          case "N":
            return e && e(this.value);
          case "E":
            return t && t(this.error);
          case "C":
            return r && r();
        }
      }, Notification.prototype.accept = function (e, t, r) {
        return e && "function" === typeof e.next ? this.observe(e) : this.do(e, t, r);
      }, Notification.prototype.toObservable = function () {
        switch (this.kind) {
          case "N":
            return of_of(this.value);
          case "E":
            return function throwError(e, t) {
              return new te(t ? function (r) {
                return t.schedule(throwError_dispatch, 0, {
                  error: e,
                  subscriber: r
                });
              } : function (t) {
                return t.error(e);
              });
            }(this.error);
          case "C":
            return empty_empty();
        }
        throw new Error("unexpected notification kind value");
      }, Notification.createNext = function (e) {
        return "undefined" !== typeof e ? new Notification("N", e) : Notification.undefinedValueNotification;
      }, Notification.createError = function (e) {
        return new Notification("E", void 0, e);
      }, Notification.createComplete = function () {
        return Notification.completeNotification;
      }, Notification.completeNotification = new Notification("C"), Notification.undefinedValueNotification = new Notification("N", void 0), Notification;
    }();
    function observeOn(e, t) {
      return void 0 === t && (t = 0), function observeOnOperatorFunction(r) {
        return r.lift(new he(e, t));
      };
    }
    var he = function () {
        function ObserveOnOperator(e, t) {
          void 0 === t && (t = 0), this.scheduler = e, this.delay = t;
        }
        return ObserveOnOperator.prototype.call = function (e, t) {
          return t.subscribe(new ge(e, this.scheduler, this.delay));
        }, ObserveOnOperator;
      }(),
      ge = function (e) {
        function ObserveOnSubscriber(t, r, n) {
          void 0 === n && (n = 0);
          var o = e.call(this, t) || this;
          return o.scheduler = r, o.delay = n, o;
        }
        return __extends(ObserveOnSubscriber, e), ObserveOnSubscriber.dispatch = function (e) {
          var t = e.notification,
            r = e.destination;
          t.observe(r), this.unsubscribe();
        }, ObserveOnSubscriber.prototype.scheduleMessage = function (e) {
          this.destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new be(e, this.destination)));
        }, ObserveOnSubscriber.prototype._next = function (e) {
          this.scheduleMessage(pe.createNext(e));
        }, ObserveOnSubscriber.prototype._error = function (e) {
          this.scheduleMessage(pe.createError(e)), this.unsubscribe();
        }, ObserveOnSubscriber.prototype._complete = function () {
          this.scheduleMessage(pe.createComplete()), this.unsubscribe();
        }, ObserveOnSubscriber;
      }(Q),
      be = function () {
        return function ObserveOnMessage(e, t) {
          this.notification = e, this.destination = t;
        };
      }();
    function map_map(e, t) {
      return function mapOperation(r) {
        if ("function" !== typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return r.lift(new ye(e, t));
      };
    }
    var ye = function () {
        function MapOperator(e, t) {
          this.project = e, this.thisArg = t;
        }
        return MapOperator.prototype.call = function (e, t) {
          return t.subscribe(new ve(e, this.project, this.thisArg));
        }, MapOperator;
      }(),
      ve = function (e) {
        function MapSubscriber(t, r, n) {
          var o = e.call(this, t) || this;
          return o.project = r, o.count = 0, o.thisArg = n || o, o;
        }
        return __extends(MapSubscriber, e), MapSubscriber.prototype._next = function (e) {
          var t;
          try {
            t = this.project.call(this.thisArg, e, this.count++);
          } catch (r) {
            return void this.destination.error(r);
          }
          this.destination.next(t);
        }, MapSubscriber;
      }(Q),
      me = function (e) {
        function SimpleInnerSubscriber(t) {
          var r = e.call(this) || this;
          return r.parent = t, r;
        }
        return __extends(SimpleInnerSubscriber, e), SimpleInnerSubscriber.prototype._next = function (e) {
          this.parent.notifyNext(e);
        }, SimpleInnerSubscriber.prototype._error = function (e) {
          this.parent.notifyError(e), this.unsubscribe();
        }, SimpleInnerSubscriber.prototype._complete = function () {
          this.parent.notifyComplete(), this.unsubscribe();
        }, SimpleInnerSubscriber;
      }(Q),
      Oe = function (e) {
        function SimpleOuterSubscriber() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return __extends(SimpleOuterSubscriber, e), SimpleOuterSubscriber.prototype.notifyNext = function (e) {
          this.destination.next(e);
        }, SimpleOuterSubscriber.prototype.notifyError = function (e) {
          this.destination.error(e);
        }, SimpleOuterSubscriber.prototype.notifyComplete = function () {
          this.destination.complete();
        }, SimpleOuterSubscriber;
      }(Q);
    function innerSubscribe(e, t) {
      if (!t.closed) {
        if (e instanceof te) return e.subscribe(t);
        var r;
        try {
          r = le(e)(t);
        } catch (n) {
          t.error(n);
        }
        return r;
      }
    }
    function mergeMap(e, t, r) {
      return void 0 === r && (r = Number.POSITIVE_INFINITY), "function" === typeof t ? function (n) {
        return n.pipe(mergeMap(function (r, n) {
          return from_from(e(r, n)).pipe(map_map(function (e, o) {
            return t(r, e, n, o);
          }));
        }, r));
      } : ("number" === typeof t && (r = t), function (t) {
        return t.lift(new Se(e, r));
      });
    }
    var Se = function () {
        function MergeMapOperator(e, t) {
          void 0 === t && (t = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = t;
        }
        return MergeMapOperator.prototype.call = function (e, t) {
          return t.subscribe(new _e(e, this.project, this.concurrent));
        }, MergeMapOperator;
      }(),
      _e = function (e) {
        function MergeMapSubscriber(t, r, n) {
          void 0 === n && (n = Number.POSITIVE_INFINITY);
          var o = e.call(this, t) || this;
          return o.project = r, o.concurrent = n, o.hasCompleted = !1, o.buffer = [], o.active = 0, o.index = 0, o;
        }
        return __extends(MergeMapSubscriber, e), MergeMapSubscriber.prototype._next = function (e) {
          this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
        }, MergeMapSubscriber.prototype._tryNext = function (e) {
          var t,
            r = this.index++;
          try {
            t = this.project(e, r);
          } catch (n) {
            return void this.destination.error(n);
          }
          this.active++, this._innerSub(t);
        }, MergeMapSubscriber.prototype._innerSub = function (e) {
          var t = new me(this),
            r = this.destination;
          r.add(t);
          var n = innerSubscribe(e, t);
          n !== t && r.add(n);
        }, MergeMapSubscriber.prototype._complete = function () {
          this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe();
        }, MergeMapSubscriber.prototype.notifyNext = function (e) {
          this.destination.next(e);
        }, MergeMapSubscriber.prototype.notifyComplete = function () {
          var e = this.buffer;
          this.active--, e.length > 0 ? this._next(e.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
        }, MergeMapSubscriber;
      }(Oe),
      Ae = 1,
      we = function () {
        return Promise.resolve();
      }(),
      Ee = {};
    function findAndClearHandle(e) {
      return e in Ee && (delete Ee[e], !0);
    }
    var Ce = function setImmediate(e) {
        var t = Ae++;
        return Ee[t] = !0, we.then(function () {
          return findAndClearHandle(t) && e();
        }), t;
      },
      Te = function clearImmediate(e) {
        findAndClearHandle(e);
      },
      De = function (e) {
        function AsapAction(t, r) {
          var n = e.call(this, t, r) || this;
          return n.scheduler = t, n.work = r, n;
        }
        return __extends(AsapAction, e), AsapAction.prototype.requestAsyncId = function (t, r, n) {
          return void 0 === n && (n = 0), null !== n && n > 0 ? e.prototype.requestAsyncId.call(this, t, r, n) : (t.actions.push(this), t.scheduled || (t.scheduled = Ce(t.flush.bind(t, null))));
        }, AsapAction.prototype.recycleAsyncId = function (t, r, n) {
          if (void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0) return e.prototype.recycleAsyncId.call(this, t, r, n);
          0 === t.actions.length && (Te(r), t.scheduled = void 0);
        }, AsapAction;
      }(U),
      Ie = new (function (e) {
        function AsapScheduler() {
          return null !== e && e.apply(this, arguments) || this;
        }
        return __extends(AsapScheduler, e), AsapScheduler.prototype.flush = function (e) {
          this.active = !0, this.scheduled = void 0;
          var t,
            r = this.actions,
            n = -1,
            o = r.length;
          e = e || r.shift();
          do {
            if (t = e.execute(e.state, e.delay)) break;
          } while (++n < o && (e = r.shift()));
          if (this.active = !1, t) {
            for (; ++n < o && (e = r.shift());) {
              e.unsubscribe();
            }
            throw t;
          }
        }, AsapScheduler;
      }(V))(De);
    var je = function (e) {
      function SubscribeOnObservable(t, r, n) {
        void 0 === r && (r = 0), void 0 === n && (n = Ie);
        var o = e.call(this) || this;
        return o.source = t, o.delayTime = r, o.scheduler = n, (!function isNumeric(e) {
          return !G(e) && e - parseFloat(e) + 1 >= 0;
        }(r) || r < 0) && (o.delayTime = 0), n && "function" === typeof n.schedule || (o.scheduler = Ie), o;
      }
      return __extends(SubscribeOnObservable, e), SubscribeOnObservable.create = function (e, t, r) {
        return void 0 === t && (t = 0), void 0 === r && (r = Ie), new SubscribeOnObservable(e, t, r);
      }, SubscribeOnObservable.dispatch = function (e) {
        var t = e.source,
          r = e.subscriber;
        return this.add(t.subscribe(r));
      }, SubscribeOnObservable.prototype._subscribe = function (e) {
        var t = this.delayTime,
          r = this.source;
        return this.scheduler.schedule(SubscribeOnObservable.dispatch, t, {
          source: r,
          subscriber: e
        });
      }, SubscribeOnObservable;
    }(te);
    var ke = function () {
      function SubscribeOnOperator(e, t) {
        this.scheduler = e, this.delay = t;
      }
      return SubscribeOnOperator.prototype.call = function (e, t) {
        return new je(t, this.delay, this.scheduler).subscribe(e);
      }, SubscribeOnOperator;
    }();
    function filter(e, t) {
      return function filterOperatorFunction(r) {
        return r.lift(new xe(e, t));
      };
    }
    var xe = function () {
        function FilterOperator(e, t) {
          this.predicate = e, this.thisArg = t;
        }
        return FilterOperator.prototype.call = function (e, t) {
          return t.subscribe(new Pe(e, this.predicate, this.thisArg));
        }, FilterOperator;
      }(),
      Pe = function (e) {
        function FilterSubscriber(t, r, n) {
          var o = e.call(this, t) || this;
          return o.predicate = r, o.thisArg = n, o.count = 0, o;
        }
        return __extends(FilterSubscriber, e), FilterSubscriber.prototype._next = function (e) {
          var t;
          try {
            t = this.predicate.call(this.thisArg, e, this.count++);
          } catch (r) {
            return void this.destination.error(r);
          }
          t && this.destination.next(e);
        }, FilterSubscriber;
      }(Q),
      Me = function keyHasType(e, t) {
        return e === t || "function" === typeof t && e === t.toString();
      },
      Ne = function ofType() {
        for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }
        return function (e) {
          return e.pipe(filter(function (e) {
            var r = e.type,
              n = t.length;
            if (1 === n) return Me(r, t[0]);
            for (var o = 0; o < n; o++) {
              if (Me(r, t[o])) return !0;
            }
            return !1;
          }));
        };
      },
      Re = function () {
        function defineProperties(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (e, t, r) {
          return t && defineProperties(e.prototype, t), r && defineProperties(e, r), e;
        };
      }();
    var Le = function (e) {
      function ActionsObservable(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ActionsObservable);
        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        return t.source = e, t;
      }
      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(ActionsObservable, te), Re(ActionsObservable, null, [{
        key: "of",
        value: function of() {
          return new this(of_of.apply(void 0, arguments));
        }
      }, {
        key: "from",
        value: function from(e, t) {
          return new this(from_from(e, t));
        }
      }]), Re(ActionsObservable, [{
        key: "lift",
        value: function lift(e) {
          var t = new ActionsObservable(this);
          return t.operator = e, t;
        }
      }, {
        key: "ofType",
        value: function ofType() {
          return Ne.apply(void 0, arguments)(this);
        }
      }]), ActionsObservable;
    }();
    var Be = function (e) {
      function StateObservable(e, t) {
        !function StateObservable_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, StateObservable);
        var r = function StateObservable_possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function (e) {
          var t = r.__notifier.subscribe(e);
          return t && !t.closed && e.next(r.value), t;
        }));
        return r.value = t, r.__notifier = new ie(), r.__subscription = e.subscribe(function (e) {
          e !== r.value && (r.value = e, r.__notifier.next(e));
        }), r;
      }
      return function StateObservable_inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(StateObservable, te), StateObservable;
    }();
    var Ge = i(19),
      He = i(7),
      Fe = i.n(He),
      Ue = function Ue(e) {
        return "function" === typeof e;
      },
      ze = function ze(e) {
        return e;
      },
      qe = function qe(e) {
        return null === e;
      };
    function createAction(e, t, r) {
      void 0 === t && (t = ze), Fe()(Ue(t) || qe(t), "Expected payloadCreator to be a function, undefined or null");
      var n = qe(t) || t === ze ? ze : function (e) {
          for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
            n[o - 1] = arguments[o];
          }
          return e instanceof Error ? e : t.apply(void 0, [e].concat(n));
        },
        o = Ue(r),
        i = e.toString(),
        a = function actionCreator() {
          var t = n.apply(void 0, arguments),
            i = {
              type: e
            };
          return t instanceof Error && (i.error = !0), void 0 !== t && (i.payload = t), o && (i.meta = r.apply(void 0, arguments)), i;
        };
      return a.toString = function () {
        return i;
      }, a;
    }
    var We = function makeConstant(e) {
        return "onboarding_components/".concat(e);
      },
      Ve = We("INITIALIZE"),
      Ke = We("FETCH_ORG_GOALS"),
      Ye = We("FETCH_ORG_GOALS_SUCCESS"),
      Je = We("FETCH_ORG_GOALS_PENDING"),
      Xe = We("FETCH_ORG_GOALS_FAILED"),
      $e = We("SAVE_ORG_GOALS"),
      Qe = We("SAVE_ORG_GOALS_SUCCESS"),
      Ze = We("SAVE_ORG_GOALS_PENDING"),
      et = We("SAVE_ORG_GOALS_FAILED"),
      tt = We("UPDATE_ORG_GOALS"),
      rt = createAction(Ve),
      nt = createAction(Ke),
      ot = createAction(Ye),
      it = createAction(Je),
      at = createAction(Xe),
      ct = createAction($e),
      ut = createAction(Qe),
      st = createAction(Ze),
      lt = createAction(et),
      dt = createAction(tt),
      ft = i(3),
      pt = "NOT_FOUND";
    var ht = function defaultEqualityCheck(e, t) {
      return e === t;
    };
    function defaultMemoize(e, t) {
      var r = "object" === typeof t ? t : {
          equalityCheck: t
        },
        n = r.equalityCheck,
        o = void 0 === n ? ht : n,
        i = r.maxSize,
        a = void 0 === i ? 1 : i,
        c = r.resultEqualityCheck,
        u = function createCacheKeyComparator(e) {
          return function areArgumentsShallowlyEqual(t, r) {
            if (null === t || null === r || t.length !== r.length) return !1;
            for (var n = t.length, o = 0; o < n; o++) {
              if (!e(t[o], r[o])) return !1;
            }
            return !0;
          };
        }(o),
        s = 1 === a ? function createSingletonCache(e) {
          var t;
          return {
            get: function get(r) {
              return t && e(t.key, r) ? t.value : pt;
            },
            put: function put(e, r) {
              t = {
                key: e,
                value: r
              };
            },
            getEntries: function getEntries() {
              return t ? [t] : [];
            },
            clear: function clear() {
              t = void 0;
            }
          };
        }(u) : function createLruCache(e, t) {
          var r = [];
          function get(e) {
            var n = r.findIndex(function (r) {
              return t(e, r.key);
            });
            if (n > -1) {
              var o = r[n];
              return n > 0 && (r.splice(n, 1), r.unshift(o)), o.value;
            }
            return pt;
          }
          return {
            get: get,
            put: function put(t, n) {
              get(t) === pt && (r.unshift({
                key: t,
                value: n
              }), r.length > e && r.pop());
            },
            getEntries: function getEntries() {
              return r;
            },
            clear: function clear() {
              r = [];
            }
          };
        }(a, u);
      function memoized() {
        var t = s.get(arguments);
        if (t === pt) {
          if (t = e.apply(null, arguments), c) {
            var r = s.getEntries().find(function (e) {
              return c(e.value, t);
            });
            r && (t = r.value);
          }
          s.put(arguments, t);
        }
        return t;
      }
      return memoized.clearCache = function () {
        return s.clear();
      }, memoized;
    }
    function createSelectorCreator(e) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        r[n - 1] = arguments[n];
      }
      return function createSelector() {
        for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
          n[o] = arguments[o];
        }
        var i,
          a = 0,
          c = {
            memoizeOptions: void 0
          },
          u = n.pop();
        if ("object" === typeof u && (c = u, u = n.pop()), "function" !== typeof u) throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof u + "]");
        var s = c.memoizeOptions,
          l = void 0 === s ? r : s,
          d = Array.isArray(l) ? l : [l],
          f = function getDependencies(e) {
            var t = Array.isArray(e[0]) ? e[0] : e;
            if (!t.every(function (e) {
              return "function" === typeof e;
            })) {
              var r = t.map(function (e) {
                return "function" === typeof e ? "function " + (e.name || "unnamed") + "()" : typeof e;
              }).join(", ");
              throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + r + "]");
            }
            return t;
          }(n),
          p = e.apply(void 0, [function recomputationWrapper() {
            return a++, u.apply(null, arguments);
          }].concat(d)),
          h = e(function dependenciesChecker() {
            for (var e = [], t = f.length, r = 0; r < t; r++) {
              e.push(f[r].apply(null, arguments));
            }
            return i = p.apply(null, e);
          });
        return Object.assign(h, {
          resultFunc: u,
          memoizedResultFunc: p,
          dependencies: f,
          lastResult: function lastResult() {
            return i;
          },
          recomputations: function recomputations() {
            return a;
          },
          resetRecomputations: function resetRecomputations() {
            return a = 0;
          }
        }), h;
      };
    }
    var gt = createSelectorCreator(defaultMemoize);
    function _defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
          _defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    var bt = Object.freeze({
        TOP: "TOP",
        MIDDLE: "MIDDLE",
        BOTTOM: "BOTTOM"
      }),
      yt = Object.freeze({
        INCREASE_REVENUE: "INCREASE REVENUE",
        LOWER_COST: "LOWER COST"
      }),
      vt = (Object.freeze(_objectSpread2({
        ALL: "ALL"
      }, bt)), Object.freeze([{
        id: "convert_high_volume_traffic",
        funnelPosition: yt.INCREASE_REVENUE,
        title: "Convert more high volume traffic",
        description: "Convert more high volume traffic",
        caseStudy: {
          description: "",
          href: ""
        },
        version: 1
      }, {
        id: "increase_target_account_pipeline",
        funnelPosition: yt.INCREASE_REVENUE,
        title: "Increase target account pipeline",
        description: "Increase target account pipeline",
        caseStudy: {
          description: "",
          href: ""
        }
      }, {
        id: "create_more_expansion_pipeline",
        funnelPosition: yt.INCREASE_REVENUE,
        title: "Create more expansion pipeline",
        description: "Create more expansion pipeline",
        caseStudy: {
          description: "",
          href: ""
        }
      }, {
        id: "reduce_cost_per_lead",
        funnelPosition: yt.LOWER_COST,
        title: "Reduce cost per lead",
        description: "Reduce cost per lead",
        caseStudy: {
          description: "",
          href: ""
        }
      }, {
        id: "increase_productivity_per_rep",
        funnelPosition: yt.LOWER_COST,
        title: "Increase productivity per rep",
        description: "Increase productivity per rep",
        caseStudy: {
          description: "",
          href: ""
        }
      }, {
        id: "reduce_cost_of_service",
        funnelPosition: yt.LOWER_COST,
        title: "Reduce cost of service",
        description: "Reduce cost of service",
        caseStudy: {
          description: "",
          href: ""
        }
      }].map(function (e) {
        return Object.freeze(e);
      }))),
      mt = Object.freeze([{
        id: "leads_captured",
        funnelPosition: bt.TOP,
        title: "Leads captured",
        description: "The volume of emails captured",
        caseStudy: {
          description: "WebPT tripled their monthly chat leads",
          href: "https://www.drift.com/blog/webpt-success-story/"
        }
      }, {
        id: "lead_capture_rate",
        funnelPosition: bt.TOP,
        title: "Lead capture rate",
        description: "The percent of emails captured",
        caseStudy: {
          description: "RapidMiner's 4,000 leads and $1M pipeline",
          href: "https://www.drift.com/case-studies/rapidminer/"
        }
      }, {
        id: "qualified_leads_captured",
        funnelPosition: bt.TOP,
        title: "Qualified leads captured",
        description: "The volume of emails captured that match your criteria for potential customers",
        caseStudy: {
          description: "15Five doubled conversions with Drift",
          href: "https://www.drift.com/blog/15five-success-story/"
        }
      }, {
        id: "qualified_lead_capture_rate",
        funnelPosition: bt.TOP,
        title: "Qualified lead capture rate",
        description: "The percent of emails captured that match your criteria for potential customers",
        caseStudy: {
          description: "ConnectWise 500% conversation increase",
          href: "https://www.drift.com/blog/connectwise-success-story/"
        }
      }, {
        id: "meetings_booked",
        funnelPosition: bt.MIDDLE,
        title: "Meetings booked",
        description: "The volume of meetings or demos booked over a given time period",
        caseStudy: {
          description: "Lessonly doubled meetings in one quarter",
          href: "https://www.drift.com/blog/lessonly-success-story/"
        }
      }, {
        id: "qualified_lead_to_meeting_conversion_rate",
        funnelPosition: bt.MIDDLE,
        title: "Qualified lead/meeting conversion rate",
        description: "The percent of total qualified conversions over total meetings booked",
        caseStudy: {
          description: "Keap grew its pipeline 50% in 50 days",
          href: "https://www.drift.com/blog/keap-success-story/"
        }
      }, {
        id: "opportunities_influenced_#",
        funnelPosition: bt.BOTTOM,
        title: "Opportunities influenced #",
        description: "Volume of opportunities created or impacted by Drift",
        caseStudy: {
          description: "Marketo increased pipeline & closed deals",
          href: "https://www.drift.com/case-studies/marketo/"
        }
      }, {
        id: "opportunities_influenced_$",
        funnelPosition: bt.BOTTOM,
        title: "Opportunities influenced $",
        description: "Dollar value of opportunities created or impacted by Drift",
        caseStudy: {
          description: "RapidMiner's 4,000 leads and $1M pipeline",
          href: "https://www.drift.com/case-studies/rapidminer/"
        }
      }, {
        id: "opportunities_won",
        funnelPosition: bt.BOTTOM,
        title: "Opportunities won",
        description: "Volume of opportunities closed won that were created or impacted by Drift",
        caseStudy: {
          description: "Bynder turned live chat into $1MM in ARR",
          href: "https://www.drift.com/blog/bynder-success-story/"
        }
      }, {
        id: "revenue",
        funnelPosition: bt.BOTTOM,
        title: "Revenue",
        description: "Dollar value of revenue created or impacted by Drift",
        caseStudy: {
          description: "Bynder turned live chat into $1MM in ARR",
          href: "https://www.drift.com/blog/bynder-success-story/"
        }
      }].map(function (e) {
        return Object.freeze(e);
      })),
      Ot = Object.freeze({
        id: "id",
        funnelPosition: "funnelPosition",
        title: "title",
        description: "description",
        caseStudy: "caseStudy"
      }),
      St = function indexGoalsByProp(e) {
        return ft.indexBy(ft.prop(e), ft.union(mt, vt));
      }(Ot.id),
      _t = function getGoalById(e) {
        return ft.prop(e, St);
      },
      At = function getOrgGoals(e) {
        return e.orgGoals;
      },
      wt = gt([At], function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = ft.pluck("id", e),
          r = ft.pluck("id", mt),
          n = ft.intersection(t, r).length > 0;
        return {
          funnelGoals: n ? e : [],
          valueGoals: n ? [] : e
        };
      }),
      Et = function getFetchOrgGoalsStatus(e) {
        return e.fetchOrgGoalsStatus;
      },
      Ct = function getFetchOrgGoalsLoading(e) {
        return Et(e) !== a.fetchOrgGoalsSuccess.toString();
      },
      Tt = function getSaveOrgGoalsStatus(e) {
        return e.saveOrgGoalsStatus;
      },
      Dt = function getSaveOrgGoalsLoading(e) {
        return Tt(e) === a.saveOrgGoalsPending.toString();
      },
      It = function It() {
        for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }
        var n = "function" !== typeof t[t.length - 1] && t.pop(),
          o = t;
        if ("undefined" === typeof n) throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
        return function (e, t) {
          for (var r = arguments.length, i = Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) {
            i[a - 2] = arguments[a];
          }
          var c = "undefined" === typeof e,
            u = "undefined" === typeof t;
          return c && u && n ? n : o.reduce(function (e, r) {
            return r.apply(void 0, [e, t].concat(i));
          }, c && !u && n ? n : e);
        };
      },
      jt = function jt(e) {
        if ("object" !== typeof e || null === e) return !1;
        for (var t = e; null !== Object.getPrototypeOf(t);) {
          t = Object.getPrototypeOf(t);
        }
        return Object.getPrototypeOf(e) === t;
      },
      kt = function kt(e) {
        return "undefined" !== typeof Map && e instanceof Map;
      };
    function ownKeys_ownKeys(e) {
      if (kt(e)) return Array.from(e.keys());
      if ("undefined" !== typeof Reflect && "function" === typeof Reflect.ownKeys) return Reflect.ownKeys(e);
      var t = Object.getOwnPropertyNames(e);
      return "function" === typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e))), t;
    }
    var xt = "||";
    function get(e, t) {
      return kt(t) ? t.get(e) : t[e];
    }
    var Pt,
      Mt = (Pt = function Pt(e) {
        return (jt(e) || kt(e)) && !function hasGeneratorInterface(e) {
          var t = ownKeys_ownKeys(e),
            r = t.every(function (e) {
              return "next" === e || "throw" === e;
            });
          return t.length && t.length <= 2 && r;
        }(e);
      }, function flatten(e, t, r, n) {
        var o = void 0 === t ? {} : t,
          i = o.namespace,
          a = void 0 === i ? "/" : i,
          c = o.prefix;
        return void 0 === r && (r = {}), void 0 === n && (n = ""), ownKeys_ownKeys(e).forEach(function (t) {
          var o = function connectPrefix(e) {
              return n || !c || c && new RegExp("^" + c + a).test(e) ? e : "" + c + a + e;
            }(function connectNamespace(e) {
              var t;
              if (!n) return e;
              var r = e.toString().split(xt),
                o = n.split(xt);
              return (t = []).concat.apply(t, o.map(function (e) {
                return r.map(function (t) {
                  return "" + e + a + t;
                });
              })).join(xt);
            }(t)),
            i = get(t, e);
          Pt(i) ? flatten(i, {
            namespace: a,
            prefix: c
          }, r, o) : r[o] = i;
        }), r;
      }),
      Nt = function Nt(e) {
        return null === e || void 0 === e;
      },
      Rt = function Rt(e) {
        return void 0 === e;
      },
      Lt = function Lt(e) {
        return e.toString();
      };
    function handleActions_handleActions(e, t, r) {
      void 0 === r && (r = {}), Fe()(jt(e) || kt(e), "Expected handlers to be a plain object.");
      var n = Mt(e, r),
        o = ownKeys_ownKeys(n).map(function (e) {
          return function handleAction(e, t, r) {
            void 0 === t && (t = ze);
            var n = Lt(e).split(xt);
            Fe()(!Rt(r), "defaultState for reducer handling " + n.join(", ") + " should be defined"), Fe()(Ue(t) || jt(t), "Expected reducer to be a function or object with next and throw reducers");
            var o = Ue(t) ? [t, t] : [t.next, t.throw].map(function (e) {
                return Nt(e) ? ze : e;
              }),
              i = o[0],
              a = o[1];
            return function (e, t) {
              void 0 === e && (e = r);
              var o = t.type;
              return o && -1 !== n.indexOf(Lt(o)) ? (!0 === t.error ? a : i)(e, t) : e;
            };
          }(e, get(e, n), t);
        }),
        i = It.apply(void 0, o.concat([t]));
      return function (e, r) {
        return void 0 === e && (e = t), i(e, r);
      };
    }
    function t(e) {
      for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        r[n - 1] = arguments[n];
      }
      throw Error("[Immer] minified error nr: " + e + (r.length ? " " + r.map(function (e) {
        return "'" + e + "'";
      }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function immer_esm_n(e) {
      return !!e && !!e[Vt];
    }
    function r(e) {
      return !!e && (function (e) {
        if (!e || "object" != typeof e) return !1;
        var t = Object.getPrototypeOf(e);
        return !t || t === Object.prototype;
      }(e) || Array.isArray(e) || !!e[Wt] || !!e.constructor[Wt] || s(e) || v(e));
    }
    function immer_esm_i(e, t, r) {
      void 0 === r && (r = !1), 0 === immer_esm_o(e) ? (r ? Object.keys : Kt)(e).forEach(function (n) {
        r && "symbol" == typeof n || t(n, e[n], e);
      }) : e.forEach(function (r, n) {
        return t(n, r, e);
      });
    }
    function immer_esm_o(e) {
      var t = e[Vt];
      return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : s(e) ? 2 : v(e) ? 3 : 0;
    }
    function u(e, t) {
      return 2 === immer_esm_o(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
    }
    function immer_esm_a(e, t) {
      return 2 === immer_esm_o(e) ? e.get(t) : e[t];
    }
    function f(e, t, r) {
      var n = immer_esm_o(e);
      2 === n ? e.set(t, r) : 3 === n ? (e.delete(t), e.add(r)) : e[t] = r;
    }
    function c(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }
    function s(e) {
      return Ft && e instanceof Map;
    }
    function v(e) {
      return Ut && e instanceof Set;
    }
    function p(e) {
      return e.o || e.t;
    }
    function l(e) {
      if (Array.isArray(e)) return Array.prototype.slice.call(e);
      var t = Yt(e);
      delete t[Vt];
      for (var r = Kt(t), n = 0; n < r.length; n++) {
        var o = r[n],
          i = t[o];
        !1 === i.writable && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = {
          configurable: !0,
          writable: !0,
          enumerable: i.enumerable,
          value: e[o]
        });
      }
      return Object.create(Object.getPrototypeOf(e), t);
    }
    function d(e, t) {
      return void 0 === t && (t = !1), immer_esm_y(e) || immer_esm_n(e) || !r(e) ? e : (immer_esm_o(e) > 1 && (e.set = e.add = e.clear = e.delete = h), Object.freeze(e), t && immer_esm_i(e, function (e, t) {
        return d(t, !0);
      }, !0), e);
    }
    function h() {
      t(2);
    }
    function immer_esm_y(e) {
      return null == e || "object" != typeof e || Object.isFrozen(e);
    }
    function b(e) {
      var r = Jt[e];
      return r || t(18, e), r;
    }
    function _() {
      return Gt;
    }
    function j(e, t) {
      t && (b("Patches"), e.u = [], e.s = [], e.v = t);
    }
    function g(e) {
      w(e), e.p.forEach(S), e.p = null;
    }
    function w(e) {
      e === Gt && (Gt = e.l);
    }
    function O(e) {
      return Gt = {
        p: [],
        l: Gt,
        h: e,
        m: !0,
        _: 0
      };
    }
    function S(e) {
      var t = e[Vt];
      0 === t.i || 1 === t.i ? t.j() : t.g = !0;
    }
    function P(e, n) {
      n._ = n.p.length;
      var o = n.p[0],
        i = void 0 !== e && e !== o;
      return n.h.O || b("ES5").S(n, e, i), i ? (o[Vt].P && (g(n), t(4)), r(e) && (e = M(n, e), n.l || immer_esm_x(n, e)), n.u && b("Patches").M(o[Vt], e, n.u, n.s)) : e = M(n, o, []), g(n), n.u && n.v(n.u, n.s), e !== qt ? e : void 0;
    }
    function M(e, t, r) {
      if (immer_esm_y(t)) return t;
      var n = t[Vt];
      if (!n) return immer_esm_i(t, function (o, i) {
        return A(e, n, t, o, i, r);
      }, !0), t;
      if (n.A !== e) return t;
      if (!n.P) return immer_esm_x(e, n.t, !0), n.t;
      if (!n.I) {
        n.I = !0, n.A._--;
        var o = 4 === n.i || 5 === n.i ? n.o = l(n.k) : n.o;
        immer_esm_i(3 === n.i ? new Set(o) : o, function (t, i) {
          return A(e, n, o, t, i, r);
        }), immer_esm_x(e, o, !1), r && e.u && b("Patches").R(n, r, e.u, e.s);
      }
      return n.o;
    }
    function A(e, t, n, o, i, a) {
      if (immer_esm_n(i)) {
        var c = M(e, i, a && t && 3 !== t.i && !u(t.D, o) ? a.concat(o) : void 0);
        if (f(n, o, c), !immer_esm_n(c)) return;
        e.m = !1;
      }
      if (r(i) && !immer_esm_y(i)) {
        if (!e.h.N && e._ < 1) return;
        M(e, i), t && t.A.l || immer_esm_x(e, i);
      }
    }
    function immer_esm_x(e, t, r) {
      void 0 === r && (r = !1), e.h.N && e.m && d(t, r);
    }
    function z(e, t) {
      var r = e[Vt];
      return (r ? p(r) : e)[t];
    }
    function I(e, t) {
      if (t in e) for (var r = Object.getPrototypeOf(e); r;) {
        var n = Object.getOwnPropertyDescriptor(r, t);
        if (n) return n;
        r = Object.getPrototypeOf(r);
      }
    }
    function k(e) {
      e.P || (e.P = !0, e.l && k(e.l));
    }
    function E(e) {
      e.o || (e.o = l(e.t));
    }
    function R(e, t, r) {
      var n = s(t) ? b("MapSet").T(t, r) : v(t) ? b("MapSet").F(t, r) : e.O ? function (e, t) {
        var r = Array.isArray(e),
          n = {
            i: r ? 1 : 0,
            A: t ? t.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: t,
            t: e,
            k: null,
            o: null,
            j: null,
            C: !1
          },
          o = n,
          i = Xt;
        r && (o = [n], i = $t);
        var a = Proxy.revocable(o, i),
          c = a.revoke,
          u = a.proxy;
        return n.k = u, n.j = c, u;
      }(t, r) : b("ES5").J(t, r);
      return (r ? r.A : _()).p.push(n), n;
    }
    function N(e, t) {
      switch (t) {
        case 2:
          return new Map(e);
        case 3:
          return Array.from(e);
      }
      return l(e);
    }
    var Bt,
      Gt,
      Ht = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
      Ft = "undefined" != typeof Map,
      Ut = "undefined" != typeof Set,
      zt = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
      qt = Ht ? Symbol.for("immer-nothing") : ((Bt = {})["immer-nothing"] = !0, Bt),
      Wt = Ht ? Symbol.for("immer-draftable") : "__$immer_draftable",
      Vt = Ht ? Symbol.for("immer-state") : "__$immer_state",
      Kt = ("undefined" != typeof Symbol && Symbol.iterator, "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
      } : Object.getOwnPropertyNames),
      Yt = Object.getOwnPropertyDescriptors || function (e) {
        var t = {};
        return Kt(e).forEach(function (r) {
          t[r] = Object.getOwnPropertyDescriptor(e, r);
        }), t;
      },
      Jt = {},
      Xt = {
        get: function get(e, t) {
          if (t === Vt) return e;
          var n = p(e);
          if (!u(n, t)) return function (e, t, r) {
            var n,
              o = I(t, r);
            return o ? "value" in o ? o.value : null === (n = o.get) || void 0 === n ? void 0 : n.call(e.k) : void 0;
          }(e, n, t);
          var o = n[t];
          return e.I || !r(o) ? o : o === z(e.t, t) ? (E(e), e.o[t] = R(e.A.h, o, e)) : o;
        },
        has: function has(e, t) {
          return t in p(e);
        },
        ownKeys: function ownKeys(e) {
          return Reflect.ownKeys(p(e));
        },
        set: function set(e, t, r) {
          var n = I(p(e), t);
          if (null == n ? void 0 : n.set) return n.set.call(e.k, r), !0;
          if (!e.P) {
            var o = z(p(e), t),
              i = null == o ? void 0 : o[Vt];
            if (i && i.t === r) return e.o[t] = r, e.D[t] = !1, !0;
            if (c(r, o) && (void 0 !== r || u(e.t, t))) return !0;
            E(e), k(e);
          }
          return e.o[t] = r, e.D[t] = !0, !0;
        },
        deleteProperty: function deleteProperty(e, t) {
          return void 0 !== z(e.t, t) || t in e.t ? (e.D[t] = !1, E(e), k(e)) : delete e.D[t], e.o && delete e.o[t], !0;
        },
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
          var r = p(e),
            n = Reflect.getOwnPropertyDescriptor(r, t);
          return n ? {
            writable: !0,
            configurable: 1 !== e.i || "length" !== t,
            enumerable: n.enumerable,
            value: r[t]
          } : n;
        },
        defineProperty: function defineProperty() {
          t(11);
        },
        getPrototypeOf: function getPrototypeOf(e) {
          return Object.getPrototypeOf(e.t);
        },
        setPrototypeOf: function setPrototypeOf() {
          t(12);
        }
      },
      $t = {};
    immer_esm_i(Xt, function (e, t) {
      $t[e] = function () {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
      };
    }), $t.deleteProperty = function (e, t) {
      return Xt.deleteProperty.call(this, e[0], t);
    }, $t.set = function (e, t, r) {
      return Xt.set.call(this, e[0], t, r, e[0]);
    };
    var Qt = new (function () {
        function e(e) {
          this.O = zt, this.N = !0, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze), this.produce = this.produce.bind(this), this.produceWithPatches = this.produceWithPatches.bind(this);
        }
        var n = e.prototype;
        return n.produce = function (e, n, o) {
          if ("function" == typeof e && "function" != typeof n) {
            var i = n;
            n = e;
            var a = this;
            return function (e) {
              var t = this;
              void 0 === e && (e = i);
              for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++) {
                o[c - 1] = arguments[c];
              }
              return a.produce(e, function (e) {
                var r;
                return (r = n).call.apply(r, [t, e].concat(o));
              });
            };
          }
          var c;
          if ("function" != typeof n && t(6), void 0 !== o && "function" != typeof o && t(7), r(e)) {
            var u = O(this),
              s = R(this, e, void 0),
              l = !0;
            try {
              c = n(s), l = !1;
            } finally {
              l ? g(u) : w(u);
            }
            return "undefined" != typeof Promise && c instanceof Promise ? c.then(function (e) {
              return j(u, o), P(e, u);
            }, function (e) {
              throw g(u), e;
            }) : (j(u, o), P(c, u));
          }
          if (!e || "object" != typeof e) {
            if ((c = n(e)) === qt) return;
            return void 0 === c && (c = e), this.N && d(c, !0), c;
          }
          t(21, e);
        }, n.produceWithPatches = function (e, t) {
          var r,
            n,
            o = this;
          return "function" == typeof e ? function (t) {
            for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
              n[i - 1] = arguments[i];
            }
            return o.produceWithPatches(t, function (t) {
              return e.apply(void 0, [t].concat(n));
            });
          } : [this.produce(e, t, function (e, t) {
            r = e, n = t;
          }), r, n];
        }, n.createDraft = function (e) {
          r(e) || t(8), immer_esm_n(e) && (e = function D(e) {
            return immer_esm_n(e) || t(22, e), function t(e) {
              if (!r(e)) return e;
              var n,
                o = e[Vt],
                i = immer_esm_o(e);
              if (o) {
                if (!o.P && (o.i < 4 || !b("ES5").K(o))) return o.t;
                o.I = !0, n = N(e, i), o.I = !1;
              } else n = N(e, i);
              return immer_esm_i(n, function (e, r) {
                o && immer_esm_a(o.t, e) === r || f(n, e, t(r));
              }), 3 === i ? new Set(n) : n;
            }(e);
          }(e));
          var n = O(this),
            o = R(this, e, void 0);
          return o[Vt].C = !0, w(n), o;
        }, n.finishDraft = function (e, t) {
          var r = (e && e[Vt]).A;
          return j(r, t), P(void 0, r);
        }, n.setAutoFreeze = function (e) {
          this.N = e;
        }, n.setUseProxies = function (e) {
          e && !zt && t(20), this.O = e;
        }, n.applyPatches = function (e, t) {
          var r;
          for (r = t.length - 1; r >= 0; r--) {
            var n = t[r];
            if (0 === n.path.length && "replace" === n.op) {
              e = n.value;
              break;
            }
          }
          var o = b("Patches").$;
          return immer_esm_n(e) ? o(e, t) : this.produce(e, function (e) {
            return o(e, t.slice(r + 1));
          });
        }, e;
      }())(),
      Zt = Qt.produce,
      er = (Qt.produceWithPatches.bind(Qt), Qt.setAutoFreeze.bind(Qt), Qt.setUseProxies.bind(Qt), Qt.applyPatches.bind(Qt), Qt.createDraft.bind(Qt), Qt.finishDraft.bind(Qt), Zt),
      tr = function tr(e) {
        return "symbol" === typeof e || "object" === typeof e && "[object Symbol]" === Object.prototype.toString.call(e);
      },
      rr = function rr(e) {
        return 0 === e.length;
      },
      nr = function nr(e) {
        return "string" === typeof e;
      };
    function isValidActionType(e) {
      return nr(e) || Ue(e) || tr(e);
    }
    function combineActions() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }
      Fe()(function isValidActionTypes(e) {
        return !rr(e) && e.every(isValidActionType);
      }(t), "Expected action types to be strings, symbols, or action creators");
      var n = t.map(Lt).join(xt);
      return {
        toString: function toString() {
          return n;
        }
      };
    }
    var or = function handleActions(e, t) {
        return handleActions_handleActions(Object.keys(e).reduce(function (t, r) {
          return t[r] = er(e[r]), t;
        }, {}), t);
      },
      ir = or(_defineProperty({}, combineActions(ot, dt), function (e, t) {
        return t.payload;
      }), !1),
      ar = or(_defineProperty({}, combineActions(ot, it, at), function (e, t) {
        return t.type;
      }), !1),
      cr = or(_defineProperty({}, combineActions(ut, st, lt), function (e, t) {
        return t.type;
      }), !1),
      ur = Object(x.combineReducers)({
        orgGoals: ir,
        fetchOrgGoalsStatus: ar,
        saveOrgGoalsStatus: cr
      });
    function mergeAll(e) {
      return void 0 === e && (e = Number.POSITIVE_INFINITY), mergeMap(identity, e);
    }
    function switchMap(e, t) {
      return "function" === typeof t ? function (r) {
        return r.pipe(switchMap(function (r, n) {
          return from_from(e(r, n)).pipe(map_map(function (e, o) {
            return t(r, e, n, o);
          }));
        }));
      } : function (t) {
        return t.lift(new sr(e));
      };
    }
    var sr = function () {
        function SwitchMapOperator(e) {
          this.project = e;
        }
        return SwitchMapOperator.prototype.call = function (e, t) {
          return t.subscribe(new lr(e, this.project));
        }, SwitchMapOperator;
      }(),
      lr = function (e) {
        function SwitchMapSubscriber(t, r) {
          var n = e.call(this, t) || this;
          return n.project = r, n.index = 0, n;
        }
        return __extends(SwitchMapSubscriber, e), SwitchMapSubscriber.prototype._next = function (e) {
          var t,
            r = this.index++;
          try {
            t = this.project(e, r);
          } catch (n) {
            return void this.destination.error(n);
          }
          this._innerSub(t);
        }, SwitchMapSubscriber.prototype._innerSub = function (e) {
          var t = this.innerSubscription;
          t && t.unsubscribe();
          var r = new me(this),
            n = this.destination;
          n.add(r), this.innerSubscription = innerSubscribe(e, r), this.innerSubscription !== r && n.add(this.innerSubscription);
        }, SwitchMapSubscriber.prototype._complete = function () {
          var t = this.innerSubscription;
          t && !t.closed || e.prototype._complete.call(this), this.unsubscribe();
        }, SwitchMapSubscriber.prototype._unsubscribe = function () {
          this.innerSubscription = void 0;
        }, SwitchMapSubscriber.prototype.notifyComplete = function () {
          this.innerSubscription = void 0, this.isStopped && e.prototype._complete.call(this);
        }, SwitchMapSubscriber.prototype.notifyNext = function (e) {
          this.destination.next(e);
        }, SwitchMapSubscriber;
      }(Oe);
    function concat() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
      return function concatAll() {
        return mergeAll(1);
      }()(of_of.apply(void 0, e));
    }
    function startWith() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
      var r = e[e.length - 1];
      return isScheduler(r) ? (e.pop(), function (t) {
        return concat(e, t, r);
      }) : function (t) {
        return concat(e, t);
      };
    }
    function catchError(e) {
      return function catchErrorOperatorFunction(t) {
        var r = new dr(e),
          n = t.lift(r);
        return r.caught = n;
      };
    }
    var dr = function () {
        function CatchOperator(e) {
          this.selector = e;
        }
        return CatchOperator.prototype.call = function (e, t) {
          return t.subscribe(new fr(e, this.selector, this.caught));
        }, CatchOperator;
      }(),
      fr = function (e) {
        function CatchSubscriber(t, r, n) {
          var o = e.call(this, t) || this;
          return o.selector = r, o.caught = n, o;
        }
        return __extends(CatchSubscriber, e), CatchSubscriber.prototype.error = function (t) {
          if (!this.isStopped) {
            var r = void 0;
            try {
              r = this.selector(t, this.caught);
            } catch (i) {
              return void e.prototype.error.call(this, i);
            }
            this._unsubscribeAndRecycle();
            var n = new me(this);
            this.add(n);
            var o = innerSubscribe(r, n);
            o !== n && this.add(o);
          }
        }, CatchSubscriber;
      }(Oe);
    function pluck() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }
      var r = e.length;
      if (0 === r) throw new Error("list of properties cannot be empty.");
      return function (t) {
        return map_map(function plucker(e, t) {
          return function mapper(r) {
            for (var n = r, o = 0; o < t; o++) {
              var i = null != n ? n[e[o]] : void 0;
              if (void 0 === i) return;
              n = i;
            }
            return n;
          };
        }(e, r))(t);
      };
    }
    var pr = i(9),
      hr = {
        QA: {},
        EU: {},
        US: {}
      },
      gr = _objectSpread2({
        IS_PRODUCTION: "PRODUCTION" === window.__ENV__,
        IS_QA: "MASTER" === window.__ENV__
      }, window.DRIFT_CONFIG || {}, {}, hr[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]),
      br = function requestWithMinWait(e, t) {
        return Promise.all([e, new Promise(function (e) {
          return setTimeout(e, t);
        })]).then(function (e) {
          return e[0];
        });
      },
      yr = ft.prop("data"),
      vr = Object(pr.createAuthedHttpClient)({
        baseConfig: {
          baseURL: gr.ALL_ABOARD_API
        }
      });
    vr.interceptors.response.use(yr, function pluckErrorResponseAndReject(e) {
      return Promise.reject(e.response);
    });
    var mr = Object(pr.createAuthedHttpClient)({
        baseConfig: {
          baseURL: gr.CUSTOMER_API
        },
        responseSuccessHandlers: [],
        responseErrorHandlers: []
      }),
      Or = function trackOrganizationGoalSelection(e) {
        return function trackEvent(e) {
          var t,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return null === (t = window.analytics) || void 0 === t ? void 0 : t.track(e, _objectSpread2({
            appName: "onboarding-components"
          }, r));
        }("Organization Goals Selected", {
          goals: e
        });
      },
      Sr = function combineEpics() {
        for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }
        var n = function merger() {
          for (var e = arguments.length, r = Array(e), n = 0; n < e; n++) {
            r[n] = arguments[n];
          }
          return function merge() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
            var r = Number.POSITIVE_INFINITY,
              n = null,
              o = e[e.length - 1];
            return isScheduler(o) ? (n = e.pop(), e.length > 1 && "number" === typeof e[e.length - 1] && (r = e.pop())) : "number" === typeof o && (r = e.pop()), null === n && 1 === e.length && e[0] instanceof te ? e[0] : mergeAll(r)(fromArray(e, n));
          }.apply(void 0, function _toConsumableArray(e) {
            if (Array.isArray(e)) {
              for (var t = 0, r = Array(e.length); t < e.length; t++) {
                r[t] = e[t];
              }
              return r;
            }
            return Array.from(e);
          }(t.map(function (e) {
            var t = e.apply(void 0, r);
            if (!t) throw new TypeError('combineEpics: one of the provided Epics "' + (e.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return t;
          })));
        };
        try {
          Object.defineProperty(n, "name", {
            value: "combineEpics(" + t.map(function (e) {
              return e.name || "<anonymous>";
            }).join(", ") + ")"
          });
        } catch (o) {}
        return n;
      }(function initialize(e) {
        return e.pipe(Ne(a.initialize.toString()), filter(pr.getAccessToken), switchMap(function () {
          return from_from(br(function fetchGoals() {
            return vr.get("/customer_goals");
          }(), 2e3)).pipe(map_map(function (e) {
            return a.fetchOrgGoalsSuccess(e.map(_t).filter(Boolean));
          }), startWith(a.fetchOrgGoalsPending()), catchError(function () {
            return of_of(a.fetchOrgGoalsFailed());
          }));
        }));
      }, function saveOrgGoals(e, t) {
        return e.pipe(Ne(a.saveOrgGoals.toString()), pluck("payload"), switchMap(function () {
          var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).callback,
            r = y.getOrgGoals(t.value),
            n = ft.pluck(Ot.id, r),
            o = ft.map(ft.dissoc(Ot.description));
          return Or(o(r)), from_from(br(function saveGoals(e) {
            return vr.post("/customer_goals", e);
          }(n), 1500)).pipe(map_map(function (t) {
            return e && e(), a.saveOrgGoalsSuccess(t);
          }), startWith(a.saveOrgGoalsPending()), catchError(function () {
            return of_of(a.saveOrgGoalsFailed());
          }));
        }));
      }),
      _r = function useActions(e) {
        for (var t = Ir(), r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          n[o - 1] = arguments[o];
        }
        return Object(C.useMemo)(function () {
          return Array.isArray(e) ? e.map(function (e) {
            return Object(x.bindActionCreators)(e, t);
          }) : Object(x.bindActionCreators)(e, t);
        }, n ? [t].concat(n) : [t]);
      },
      Ar = function useSavingOrgGoals() {
        return Dr(y.getSaveOrgGoalsLoading);
      },
      wr = function useOrgGoals() {
        return Dr(y.getOrgGoals);
      },
      Er = function useUpdateOrgGoals() {
        return _r(a.updateOrgGoals);
      },
      Cr = function useSaveOrgGoals() {
        return _r(a.saveOrgGoals);
      },
      Tr = T.a.createContext(null),
      Dr = Object(L.createSelectorHook)(Tr),
      Ir = Object(L.createDispatchHook)(Tr),
      jr = Object(Ge.composeWithDevTools)({
        trace: !0,
        traceLimit: 25
      }),
      kr = function createEpicMiddleware() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = new (0, K.constructor)(K.SchedulerAction),
          r = new ie(),
          n = void 0,
          o = function epicMiddleware(o) {
            n = o;
            var i = new ie().pipe(observeOn(t)),
              a = new ie().pipe(observeOn(t)),
              c = new Le(i),
              u = new Be(a, n.getState());
            return r.pipe(map_map(function (t) {
              var r = "dependencies" in e ? t(c, u, e.dependencies) : t(c, u);
              if (!r) throw new TypeError('Your root Epic "' + (t.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
              return r;
            }), mergeMap(function (e) {
              return from_from(e).pipe(function subscribeOn(e, t) {
                return void 0 === t && (t = 0), function subscribeOnOperatorFunction(r) {
                  return r.lift(new ke(e, t));
                };
              }(t), observeOn(t));
            })).subscribe(n.dispatch), function (e) {
              return function (t) {
                var r = e(t);
                return a.next(n.getState()), i.next(t), r;
              };
            };
          };
        return o.run = function (e) {
          r.next(e);
        }, o;
      }(),
      xr = Object(x.createStore)(ur, jr(Object(x.applyMiddleware)(kr)));
    kr.run(Sr);
    var Pr = function OnboardingProvider(e) {
      var t = e.children;
      return Object(C.useEffect)(function () {
        xr.dispatch(a.initialize());
      }, []), T.a.createElement(L.Provider, {
        context: Tr,
        store: xr
      }, t);
    };
    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function _unsupportedIterableToArray(e, t) {
      if (e) {
        if ("string" === typeof e) return _arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
      }
    }
    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
            n = !0,
            o = !1,
            i = void 0;
          try {
            for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (u) {
            o = !0, i = u;
          } finally {
            try {
              n || null == c.return || c.return();
            } finally {
              if (o) throw i;
            }
          }
          return r;
        }
      }(e, t) || _unsupportedIterableToArray(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function _objectWithoutProperties(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = function _objectWithoutPropertiesLoose(e, t) {
          if (null == e) return {};
          var r,
            n,
            o = {},
            i = Object.keys(e);
          for (n = 0; n < i.length; n++) {
            r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
          }
          return o;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }
      return o;
    }
    var Mr = i(5),
      Nr = i.n(Mr),
      Rr = i(2),
      Lr = i(20),
      Br = i.n(Lr);
    function toConsumableArray_toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) return _arrayLikeToArray(e);
      }(e) || function _iterableToArray(e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || _unsupportedIterableToArray(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function memoize(e) {
      var t = null;
      return function memoized() {
        return null == t && (t = e()), t;
      };
    }
    function _defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var Gr = function () {
        function EnterLeaveCounter(e) {
          !function EnterLeaveCounter_classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, EnterLeaveCounter), this.entered = [], this.isNodeInDocument = e;
        }
        return function EnterLeaveCounter_createClass(e, t, r) {
          return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
        }(EnterLeaveCounter, [{
          key: "enter",
          value: function enter(e) {
            var t = this,
              r = this.entered.length;
            return this.entered = function union(e, t) {
              var r = new Set(),
                n = function insertItem(e) {
                  return r.add(e);
                };
              e.forEach(n), t.forEach(n);
              var o = [];
              return r.forEach(function (e) {
                return o.push(e);
              }), o;
            }(this.entered.filter(function isNodeEntered(r) {
              return t.isNodeInDocument(r) && (!r.contains || r.contains(e));
            }), [e]), 0 === r && this.entered.length > 0;
          }
        }, {
          key: "leave",
          value: function leave(e) {
            var t = this.entered.length;
            return this.entered = function without(e, t) {
              return e.filter(function (e) {
                return e !== t;
              });
            }(this.entered.filter(this.isNodeInDocument), e), t > 0 && 0 === this.entered.length;
          }
        }, {
          key: "reset",
          value: function reset() {
            this.entered = [];
          }
        }]), EnterLeaveCounter;
      }(),
      Hr = memoize(function () {
        return /firefox/i.test(navigator.userAgent);
      }),
      Fr = memoize(function () {
        return Boolean(window.safari);
      });
    function MonotonicInterpolant_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var Ur = function () {
        function MonotonicInterpolant(e, t) {
          !function MonotonicInterpolant_classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, MonotonicInterpolant);
          for (var r = e.length, n = [], o = 0; o < r; o++) {
            n.push(o);
          }
          n.sort(function (t, r) {
            return e[t] < e[r] ? -1 : 1;
          });
          for (var i, a, c = [], u = [], s = [], l = 0; l < r - 1; l++) {
            i = e[l + 1] - e[l], a = t[l + 1] - t[l], u.push(i), c.push(a), s.push(a / i);
          }
          for (var d = [s[0]], f = 0; f < u.length - 1; f++) {
            var p = s[f],
              h = s[f + 1];
            if (p * h <= 0) d.push(0);else {
              i = u[f];
              var g = u[f + 1],
                b = i + g;
              d.push(3 * b / ((b + g) / p + (b + i) / h));
            }
          }
          d.push(s[s.length - 1]);
          for (var y, v = [], m = [], O = 0; O < d.length - 1; O++) {
            y = s[O];
            var S = d[O],
              _ = 1 / u[O],
              A = S + d[O + 1] - y - y;
            v.push((y - S - A) * _), m.push(A * _ * _);
          }
          this.xs = e, this.ys = t, this.c1s = d, this.c2s = v, this.c3s = m;
        }
        return function MonotonicInterpolant_createClass(e, t, r) {
          return t && MonotonicInterpolant_defineProperties(e.prototype, t), r && MonotonicInterpolant_defineProperties(e, r), e;
        }(MonotonicInterpolant, [{
          key: "interpolate",
          value: function interpolate(e) {
            var t = this.xs,
              r = this.ys,
              n = this.c1s,
              o = this.c2s,
              i = this.c3s,
              a = t.length - 1;
            if (e === t[a]) return r[a];
            for (var c, u = 0, s = i.length - 1; u <= s;) {
              var l = t[c = Math.floor(.5 * (u + s))];
              if (l < e) u = c + 1;else {
                if (!(l > e)) return r[c];
                s = c - 1;
              }
            }
            var d = e - t[a = Math.max(0, s)],
              f = d * d;
            return r[a] + n[a] * d + o[a] * f + i[a] * d * f;
          }
        }]), MonotonicInterpolant;
      }(),
      zr = 1;
    function getNodeClientOffset(e) {
      var t = e.nodeType === zr ? e : e.parentElement;
      if (!t) return null;
      var r = t.getBoundingClientRect(),
        n = r.top;
      return {
        x: r.left,
        y: n
      };
    }
    function getEventClientOffset(e) {
      return {
        x: e.clientX,
        y: e.clientY
      };
    }
    function getDragPreviewOffset(e, t, r, n, o) {
      var i = function isImageNode(e) {
          var t;
          return "IMG" === e.nodeName && (Hr() || !(null === (t = document.documentElement) || void 0 === t ? void 0 : t.contains(e)));
        }(t),
        a = getNodeClientOffset(i ? e : t),
        c = {
          x: r.x - a.x,
          y: r.y - a.y
        },
        u = e.offsetWidth,
        s = e.offsetHeight,
        l = n.anchorX,
        d = n.anchorY,
        f = function getDragPreviewSize(e, t, r, n) {
          var o = e ? t.width : r,
            i = e ? t.height : n;
          return Fr() && e && (i /= window.devicePixelRatio, o /= window.devicePixelRatio), {
            dragPreviewWidth: o,
            dragPreviewHeight: i
          };
        }(i, t, u, s),
        p = f.dragPreviewWidth,
        h = f.dragPreviewHeight,
        g = o.offsetX,
        b = o.offsetY,
        y = 0 === b || b;
      return {
        x: 0 === g || g ? g : function calculateXOffset() {
          return new Ur([0, .5, 1], [c.x, c.x / u * p, c.x + p - u]).interpolate(l);
        }(),
        y: y ? b : function calculateYOffset() {
          var e = new Ur([0, .5, 1], [c.y, c.y / s * h, c.y + h - s]).interpolate(d);
          return Fr() && i && (e += (window.devicePixelRatio - 1) * h), e;
        }()
      };
    }
    var qr,
      Wr = "__NATIVE_FILE__",
      Vr = "__NATIVE_URL__",
      Kr = "__NATIVE_TEXT__";
    function getDataFromDataTransfer(e, t, r) {
      var n = t.reduce(function (t, r) {
        return t || e.getData(r);
      }, "");
      return null != n ? n : r;
    }
    function nativeTypesConfig_defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var Yr = (nativeTypesConfig_defineProperty(qr = {}, Wr, {
      exposeProperties: {
        files: function files(e) {
          return Array.prototype.slice.call(e.files);
        },
        items: function items(e) {
          return e.items;
        }
      },
      matchesTypes: ["Files"]
    }), nativeTypesConfig_defineProperty(qr, Vr, {
      exposeProperties: {
        urls: function urls(e, t) {
          return getDataFromDataTransfer(e, t, "").split("\n");
        }
      },
      matchesTypes: ["Url", "text/uri-list"]
    }), nativeTypesConfig_defineProperty(qr, Kr, {
      exposeProperties: {
        text: function text(e, t) {
          return getDataFromDataTransfer(e, t, "");
        }
      },
      matchesTypes: ["Text", "text/plain"]
    }), qr);
    function NativeDragSource_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var Jr = function () {
      function NativeDragSource(e) {
        !function NativeDragSource_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, NativeDragSource), this.config = e, this.item = {}, this.initializeExposedProperties();
      }
      return function NativeDragSource_createClass(e, t, r) {
        return t && NativeDragSource_defineProperties(e.prototype, t), r && NativeDragSource_defineProperties(e, r), e;
      }(NativeDragSource, [{
        key: "initializeExposedProperties",
        value: function initializeExposedProperties() {
          var e = this;
          Object.keys(this.config.exposeProperties).forEach(function (t) {
            Object.defineProperty(e.item, t, {
              configurable: !0,
              enumerable: !0,
              get: function get() {
                return console.warn("Browser doesn't allow reading \"".concat(t, '" until the drop event.')), null;
              }
            });
          });
        }
      }, {
        key: "loadDataTransfer",
        value: function loadDataTransfer(e) {
          var t = this;
          if (e) {
            var r = {};
            Object.keys(this.config.exposeProperties).forEach(function (n) {
              r[n] = {
                value: t.config.exposeProperties[n](e, t.config.matchesTypes),
                configurable: !0,
                enumerable: !0
              };
            }), Object.defineProperties(this.item, r);
          }
        }
      }, {
        key: "canDrag",
        value: function canDrag() {
          return !0;
        }
      }, {
        key: "beginDrag",
        value: function beginDrag() {
          return this.item;
        }
      }, {
        key: "isDragging",
        value: function isDragging(e, t) {
          return t === e.getSourceId();
        }
      }, {
        key: "endDrag",
        value: function endDrag() {}
      }]), NativeDragSource;
    }();
    function matchNativeItemType(e) {
      if (!e) return null;
      var t = Array.prototype.slice.call(e.types || []);
      return Object.keys(Yr).filter(function (e) {
        return Yr[e].matchesTypes.some(function (e) {
          return t.indexOf(e) > -1;
        });
      })[0] || null;
    }
    function OptionsReader_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var Xr = function () {
      function OptionsReader(e) {
        !function OptionsReader_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, OptionsReader), this.globalContext = e;
      }
      return function OptionsReader_createClass(e, t, r) {
        return t && OptionsReader_defineProperties(e.prototype, t), r && OptionsReader_defineProperties(e, r), e;
      }(OptionsReader, [{
        key: "window",
        get: function get() {
          return this.globalContext ? this.globalContext : "undefined" !== typeof window ? window : void 0;
        }
      }, {
        key: "document",
        get: function get() {
          if (this.window) return this.window.document;
        }
      }]), OptionsReader;
    }();
    function HTML5BackendImpl_ownKeys(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function _objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? HTML5BackendImpl_ownKeys(Object(r), !0).forEach(function (t) {
          HTML5BackendImpl_defineProperty(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HTML5BackendImpl_ownKeys(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function HTML5BackendImpl_defineProperty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function HTML5BackendImpl_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var $r = function () {
        function HTML5BackendImpl(e, t) {
          var r = this;
          !function HTML5BackendImpl_classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, HTML5BackendImpl), this.sourcePreviewNodes = new Map(), this.sourcePreviewNodeOptions = new Map(), this.sourceNodes = new Map(), this.sourceNodeOptions = new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.getSourceClientOffset = function (e) {
            var t = r.sourceNodes.get(e);
            return t && getNodeClientOffset(t) || null;
          }, this.endDragNativeItem = function () {
            r.isDraggingNativeItem() && (r.actions.endDrag(), r.currentNativeHandle && r.registry.removeSource(r.currentNativeHandle), r.currentNativeHandle = null, r.currentNativeSource = null);
          }, this.isNodeInDocument = function (e) {
            return Boolean(e && r.document && r.document.body && document.body.contains(e));
          }, this.endDragIfSourceWasRemovedFromDOM = function () {
            var e = r.currentDragSourceNode;
            r.isNodeInDocument(e) || r.clearCurrentDragSourceNode() && r.actions.endDrag();
          }, this.handleTopDragStartCapture = function () {
            r.clearCurrentDragSourceNode(), r.dragStartSourceIds = [];
          }, this.handleTopDragStart = function (e) {
            if (!e.defaultPrevented) {
              var t = r.dragStartSourceIds;
              r.dragStartSourceIds = null;
              var n = getEventClientOffset(e);
              r.monitor.isDragging() && r.actions.endDrag(), r.actions.beginDrag(t || [], {
                publishSource: !1,
                getSourceClientOffset: r.getSourceClientOffset,
                clientOffset: n
              });
              var o = e.dataTransfer,
                i = matchNativeItemType(o);
              if (r.monitor.isDragging()) {
                if (o && "function" === typeof o.setDragImage) {
                  var a = r.monitor.getSourceId(),
                    c = r.sourceNodes.get(a),
                    u = r.sourcePreviewNodes.get(a) || c;
                  if (u) {
                    var s = r.getCurrentSourcePreviewNodeOptions(),
                      l = getDragPreviewOffset(c, u, n, {
                        anchorX: s.anchorX,
                        anchorY: s.anchorY
                      }, {
                        offsetX: s.offsetX,
                        offsetY: s.offsetY
                      });
                    o.setDragImage(u, l.x, l.y);
                  }
                }
                try {
                  null === o || void 0 === o || o.setData("application/json", {});
                } catch (d) {}
                r.setCurrentDragSourceNode(e.target), r.getCurrentSourcePreviewNodeOptions().captureDraggingState ? r.actions.publishDragSource() : setTimeout(function () {
                  return r.actions.publishDragSource();
                }, 0);
              } else if (i) r.beginDragNativeItem(i);else {
                if (o && !o.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) return;
                e.preventDefault();
              }
            }
          }, this.handleTopDragEndCapture = function () {
            r.clearCurrentDragSourceNode() && r.actions.endDrag();
          }, this.handleTopDragEnterCapture = function (e) {
            if (r.dragEnterTargetIds = [], r.enterLeaveCounter.enter(e.target) && !r.monitor.isDragging()) {
              var t = e.dataTransfer,
                n = matchNativeItemType(t);
              n && r.beginDragNativeItem(n, t);
            }
          }, this.handleTopDragEnter = function (e) {
            var t = r.dragEnterTargetIds;
            (r.dragEnterTargetIds = [], r.monitor.isDragging()) && (r.altKeyPressed = e.altKey, Hr() || r.actions.hover(t, {
              clientOffset: getEventClientOffset(e)
            }), t.some(function (e) {
              return r.monitor.canDropOnTarget(e);
            }) && (e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = r.getCurrentDropEffect())));
          }, this.handleTopDragOverCapture = function () {
            r.dragOverTargetIds = [];
          }, this.handleTopDragOver = function (e) {
            var t = r.dragOverTargetIds;
            if (r.dragOverTargetIds = [], !r.monitor.isDragging()) return e.preventDefault(), void (e.dataTransfer && (e.dataTransfer.dropEffect = "none"));
            r.altKeyPressed = e.altKey, r.actions.hover(t || [], {
              clientOffset: getEventClientOffset(e)
            }), (t || []).some(function (e) {
              return r.monitor.canDropOnTarget(e);
            }) ? (e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = r.getCurrentDropEffect())) : r.isDraggingNativeItem() ? e.preventDefault() : (e.preventDefault(), e.dataTransfer && (e.dataTransfer.dropEffect = "none"));
          }, this.handleTopDragLeaveCapture = function (e) {
            r.isDraggingNativeItem() && e.preventDefault(), r.enterLeaveCounter.leave(e.target) && r.isDraggingNativeItem() && r.endDragNativeItem();
          }, this.handleTopDropCapture = function (e) {
            var t;
            (r.dropTargetIds = [], e.preventDefault(), r.isDraggingNativeItem()) && (null === (t = r.currentNativeSource) || void 0 === t || t.loadDataTransfer(e.dataTransfer));
            r.enterLeaveCounter.reset();
          }, this.handleTopDrop = function (e) {
            var t = r.dropTargetIds;
            r.dropTargetIds = [], r.actions.hover(t, {
              clientOffset: getEventClientOffset(e)
            }), r.actions.drop({
              dropEffect: r.getCurrentDropEffect()
            }), r.isDraggingNativeItem() ? r.endDragNativeItem() : r.endDragIfSourceWasRemovedFromDOM();
          }, this.handleSelectStart = function (e) {
            var t = e.target;
            "function" === typeof t.dragDrop && ("INPUT" === t.tagName || "SELECT" === t.tagName || "TEXTAREA" === t.tagName || t.isContentEditable || (e.preventDefault(), t.dragDrop()));
          }, this.options = new Xr(t), this.actions = e.getActions(), this.monitor = e.getMonitor(), this.registry = e.getRegistry(), this.enterLeaveCounter = new Gr(this.isNodeInDocument);
        }
        return function HTML5BackendImpl_createClass(e, t, r) {
          return t && HTML5BackendImpl_defineProperties(e.prototype, t), r && HTML5BackendImpl_defineProperties(e, r), e;
        }(HTML5BackendImpl, [{
          key: "profile",
          value: function profile() {
            var e, t;
            return {
              sourcePreviewNodes: this.sourcePreviewNodes.size,
              sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
              sourceNodeOptions: this.sourceNodeOptions.size,
              sourceNodes: this.sourceNodes.size,
              dragStartSourceIds: (null === (e = this.dragStartSourceIds) || void 0 === e ? void 0 : e.length) || 0,
              dropTargetIds: this.dropTargetIds.length,
              dragEnterTargetIds: this.dragEnterTargetIds.length,
              dragOverTargetIds: (null === (t = this.dragOverTargetIds) || void 0 === t ? void 0 : t.length) || 0
            };
          }
        }, {
          key: "setup",
          value: function setup() {
            if (void 0 !== this.window) {
              if (this.window.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
              this.window.__isReactDndBackendSetUp = !0, this.addEventListeners(this.window);
            }
          }
        }, {
          key: "teardown",
          value: function teardown() {
            void 0 !== this.window && (this.window.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.window), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId && this.window.cancelAnimationFrame(this.asyncEndDragFrameId));
          }
        }, {
          key: "connectDragPreview",
          value: function connectDragPreview(e, t, r) {
            var n = this;
            return this.sourcePreviewNodeOptions.set(e, r), this.sourcePreviewNodes.set(e, t), function () {
              n.sourcePreviewNodes.delete(e), n.sourcePreviewNodeOptions.delete(e);
            };
          }
        }, {
          key: "connectDragSource",
          value: function connectDragSource(e, t, r) {
            var n = this;
            this.sourceNodes.set(e, t), this.sourceNodeOptions.set(e, r);
            var o = function handleDragStart(t) {
                return n.handleDragStart(t, e);
              },
              i = function handleSelectStart(e) {
                return n.handleSelectStart(e);
              };
            return t.setAttribute("draggable", "true"), t.addEventListener("dragstart", o), t.addEventListener("selectstart", i), function () {
              n.sourceNodes.delete(e), n.sourceNodeOptions.delete(e), t.removeEventListener("dragstart", o), t.removeEventListener("selectstart", i), t.setAttribute("draggable", "false");
            };
          }
        }, {
          key: "connectDropTarget",
          value: function connectDropTarget(e, t) {
            var r = this,
              n = function handleDragEnter(t) {
                return r.handleDragEnter(t, e);
              },
              o = function handleDragOver(t) {
                return r.handleDragOver(t, e);
              },
              i = function handleDrop(t) {
                return r.handleDrop(t, e);
              };
            return t.addEventListener("dragenter", n), t.addEventListener("dragover", o), t.addEventListener("drop", i), function () {
              t.removeEventListener("dragenter", n), t.removeEventListener("dragover", o), t.removeEventListener("drop", i);
            };
          }
        }, {
          key: "addEventListeners",
          value: function addEventListeners(e) {
            e.addEventListener && (e.addEventListener("dragstart", this.handleTopDragStart), e.addEventListener("dragstart", this.handleTopDragStartCapture, !0), e.addEventListener("dragend", this.handleTopDragEndCapture, !0), e.addEventListener("dragenter", this.handleTopDragEnter), e.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.addEventListener("dragover", this.handleTopDragOver), e.addEventListener("dragover", this.handleTopDragOverCapture, !0), e.addEventListener("drop", this.handleTopDrop), e.addEventListener("drop", this.handleTopDropCapture, !0));
          }
        }, {
          key: "removeEventListeners",
          value: function removeEventListeners(e) {
            e.removeEventListener && (e.removeEventListener("dragstart", this.handleTopDragStart), e.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), e.removeEventListener("dragend", this.handleTopDragEndCapture, !0), e.removeEventListener("dragenter", this.handleTopDragEnter), e.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.removeEventListener("dragover", this.handleTopDragOver), e.removeEventListener("dragover", this.handleTopDragOverCapture, !0), e.removeEventListener("drop", this.handleTopDrop), e.removeEventListener("drop", this.handleTopDropCapture, !0));
          }
        }, {
          key: "getCurrentSourceNodeOptions",
          value: function getCurrentSourceNodeOptions() {
            var e = this.monitor.getSourceId(),
              t = this.sourceNodeOptions.get(e);
            return _objectSpread({
              dropEffect: this.altKeyPressed ? "copy" : "move"
            }, t || {});
          }
        }, {
          key: "getCurrentDropEffect",
          value: function getCurrentDropEffect() {
            return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
          }
        }, {
          key: "getCurrentSourcePreviewNodeOptions",
          value: function getCurrentSourcePreviewNodeOptions() {
            var e = this.monitor.getSourceId();
            return _objectSpread({
              anchorX: .5,
              anchorY: .5,
              captureDraggingState: !1
            }, this.sourcePreviewNodeOptions.get(e) || {});
          }
        }, {
          key: "isDraggingNativeItem",
          value: function isDraggingNativeItem() {
            var e = this.monitor.getItemType();
            return Object.keys(m).some(function (t) {
              return m[t] === e;
            });
          }
        }, {
          key: "beginDragNativeItem",
          value: function beginDragNativeItem(e, t) {
            this.clearCurrentDragSourceNode(), this.currentNativeSource = function createNativeDragSource(e, t) {
              var r = new Jr(Yr[e]);
              return r.loadDataTransfer(t), r;
            }(e, t), this.currentNativeHandle = this.registry.addSource(e, this.currentNativeSource), this.actions.beginDrag([this.currentNativeHandle]);
          }
        }, {
          key: "setCurrentDragSourceNode",
          value: function setCurrentDragSourceNode(e) {
            var t = this;
            this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e;
            this.mouseMoveTimeoutTimer = setTimeout(function () {
              return t.window && t.window.addEventListener("mousemove", t.endDragIfSourceWasRemovedFromDOM, !0);
            }, 1e3);
          }
        }, {
          key: "clearCurrentDragSourceNode",
          value: function clearCurrentDragSourceNode() {
            return !!this.currentDragSourceNode && (this.currentDragSourceNode = null, this.window && (this.window.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.window.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0)), this.mouseMoveTimeoutTimer = null, !0);
          }
        }, {
          key: "handleDragStart",
          value: function handleDragStart(e, t) {
            e.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(t));
          }
        }, {
          key: "handleDragEnter",
          value: function handleDragEnter(e, t) {
            this.dragEnterTargetIds.unshift(t);
          }
        }, {
          key: "handleDragOver",
          value: function handleDragOver(e, t) {
            null === this.dragOverTargetIds && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(t);
          }
        }, {
          key: "handleDrop",
          value: function handleDrop(e, t) {
            this.dropTargetIds.unshift(t);
          }
        }, {
          key: "window",
          get: function get() {
            return this.options.window;
          }
        }, {
          key: "document",
          get: function get() {
            return this.options.document;
          }
        }]), HTML5BackendImpl;
      }(),
      Qr = function createBackend(e, t) {
        return new $r(e, t);
      },
      Zr = i(42),
      en = i(1),
      tn = "undefined" !== typeof window ? C.useLayoutEffect : C.useEffect;
    function shallowEqual(e, t, r, n) {
      var o = r ? r.call(n, e, t) : void 0;
      if (void 0 !== o) return !!o;
      if (e === t) return !0;
      if ("object" !== typeof e || !e || "object" !== typeof t || !t) return !1;
      var i = Object.keys(e),
        a = Object.keys(t);
      if (i.length !== a.length) return !1;
      for (var c = Object.prototype.hasOwnProperty.bind(t), u = 0; u < i.length; u++) {
        var s = i[u];
        if (!c(s)) return !1;
        var l = e[s],
          d = t[s];
        if (!1 === (o = r ? r.call(n, l, d, s) : void 0) || void 0 === o && l !== d) return !1;
      }
      return !0;
    }
    function useCollector_slicedToArray(e, t) {
      return function useCollector_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function useCollector_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function useCollector_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return useCollector_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return useCollector_arrayLikeToArray(e, t);
      }(e, t) || function useCollector_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function useCollector_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function useMonitorOutput_slicedToArray(e, t) {
      return function useMonitorOutput_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function useMonitorOutput_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function useMonitorOutput_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return useMonitorOutput_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return useMonitorOutput_arrayLikeToArray(e, t);
      }(e, t) || function useMonitorOutput_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function useMonitorOutput_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function useMonitorOutput(e, t, r) {
      var n = useMonitorOutput_slicedToArray(function useCollector(e, t, r) {
          var n = useCollector_slicedToArray(Object(C.useState)(function () {
              return t(e);
            }), 2),
            o = n[0],
            i = n[1],
            a = Object(C.useCallback)(function () {
              var n = t(e);
              shallowEqual(o, n) || (i(n), r && r());
            }, [o, e, r]);
          return tn(a, []), [o, a];
        }(e, t, r), 2),
        o = n[0],
        i = n[1];
      return tn(function subscribeToMonitorStateChange() {
        var t = e.getHandlerId();
        if (null != t) return e.subscribeToStateChange(i, {
          handlerIds: [t]
        });
      }, [e, i]), o;
    }
    var rn = i(10);
    function useDragDropManager() {
      var e = Object(C.useContext)(rn.a).dragDropManager;
      return Object(en.a)(null != e, "Expected drag drop context"), e;
    }
    function setRef(e, t) {
      "function" === typeof e ? e(t) : e.current = t;
    }
    function wrapHookToRecognizeElement(e) {
      return function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        if (!Object(C.isValidElement)(t)) {
          var n = t;
          return e(n, r), n;
        }
        var o = t;
        return function throwIfCompositeComponentElement(e) {
          if ("string" !== typeof e.type) {
            var t = e.type.displayName || e.type.name || "the component";
            throw new Error("Only native element nodes can now be passed to React DnD connectors." + "You can either wrap ".concat(t, " into a <div>, or turn it into a ") + "drag source or a drop target itself.");
          }
        }(o), function cloneWithRef(e, t) {
          var r = e.ref;
          return Object(en.a)("string" !== typeof r, "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute"), r ? Object(C.cloneElement)(e, {
            ref: function ref(e) {
              setRef(r, e), setRef(t, e);
            }
          }) : Object(C.cloneElement)(e, {
            ref: t
          });
        }(o, r ? function (t) {
          return e(t, r);
        } : e);
      };
    }
    function wrapConnectorHooks(e) {
      var t = {};
      return Object.keys(e).forEach(function (r) {
        var n = e[r];
        if (r.endsWith("Ref")) t[r] = e[r];else {
          var o = wrapHookToRecognizeElement(n);
          t[r] = function () {
            return o;
          };
        }
      }), t;
    }
    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function isRef(e) {
      return null !== e && "object" === _typeof(e) && Object.prototype.hasOwnProperty.call(e, "current");
    }
    function TargetConnector_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var nn = function () {
      function TargetConnector(e) {
        var t = this;
        !function TargetConnector_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, TargetConnector), this.hooks = wrapConnectorHooks({
          dropTarget: function dropTarget(e, r) {
            t.clearDropTarget(), t.dropTargetOptions = r, isRef(e) ? t.dropTargetRef = e : t.dropTargetNode = e, t.reconnect();
          }
        }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
      }
      return function TargetConnector_createClass(e, t, r) {
        return t && TargetConnector_defineProperties(e.prototype, t), r && TargetConnector_defineProperties(e, r), e;
      }(TargetConnector, [{
        key: "reconnect",
        value: function reconnect() {
          var e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
          e && this.disconnectDropTarget();
          var t = this.dropTarget;
          this.handlerId && (t ? e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = t, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, t, this.dropTargetOptions)) : this.lastConnectedDropTarget = t);
        }
      }, {
        key: "receiveHandlerId",
        value: function receiveHandlerId(e) {
          e !== this.handlerId && (this.handlerId = e, this.reconnect());
        }
      }, {
        key: "didHandlerIdChange",
        value: function didHandlerIdChange() {
          return this.lastConnectedHandlerId !== this.handlerId;
        }
      }, {
        key: "didDropTargetChange",
        value: function didDropTargetChange() {
          return this.lastConnectedDropTarget !== this.dropTarget;
        }
      }, {
        key: "didOptionsChange",
        value: function didOptionsChange() {
          return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
        }
      }, {
        key: "disconnectDropTarget",
        value: function disconnectDropTarget() {
          this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
        }
      }, {
        key: "clearDropTarget",
        value: function clearDropTarget() {
          this.dropTargetRef = null, this.dropTargetNode = null;
        }
      }, {
        key: "connectTarget",
        get: function get() {
          return this.dropTarget;
        }
      }, {
        key: "dropTargetOptions",
        get: function get() {
          return this.dropTargetOptionsInternal;
        },
        set: function set(e) {
          this.dropTargetOptionsInternal = e;
        }
      }, {
        key: "dropTarget",
        get: function get() {
          return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
        }
      }]), TargetConnector;
    }();
    function DropTargetMonitorImpl_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var on = !1,
      an = function () {
        function DropTargetMonitorImpl(e) {
          !function DropTargetMonitorImpl_classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, DropTargetMonitorImpl), this.targetId = null, this.internalMonitor = e.getMonitor();
        }
        return function DropTargetMonitorImpl_createClass(e, t, r) {
          return t && DropTargetMonitorImpl_defineProperties(e.prototype, t), r && DropTargetMonitorImpl_defineProperties(e, r), e;
        }(DropTargetMonitorImpl, [{
          key: "receiveHandlerId",
          value: function receiveHandlerId(e) {
            this.targetId = e;
          }
        }, {
          key: "getHandlerId",
          value: function getHandlerId() {
            return this.targetId;
          }
        }, {
          key: "subscribeToStateChange",
          value: function subscribeToStateChange(e, t) {
            return this.internalMonitor.subscribeToStateChange(e, t);
          }
        }, {
          key: "canDrop",
          value: function canDrop() {
            if (!this.targetId) return !1;
            Object(en.a)(!on, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
            try {
              return on = !0, this.internalMonitor.canDropOnTarget(this.targetId);
            } finally {
              on = !1;
            }
          }
        }, {
          key: "isOver",
          value: function isOver(e) {
            return !!this.targetId && this.internalMonitor.isOverTarget(this.targetId, e);
          }
        }, {
          key: "getItemType",
          value: function getItemType() {
            return this.internalMonitor.getItemType();
          }
        }, {
          key: "getItem",
          value: function getItem() {
            return this.internalMonitor.getItem();
          }
        }, {
          key: "getDropResult",
          value: function getDropResult() {
            return this.internalMonitor.getDropResult();
          }
        }, {
          key: "didDrop",
          value: function didDrop() {
            return this.internalMonitor.didDrop();
          }
        }, {
          key: "getInitialClientOffset",
          value: function getInitialClientOffset() {
            return this.internalMonitor.getInitialClientOffset();
          }
        }, {
          key: "getInitialSourceClientOffset",
          value: function getInitialSourceClientOffset() {
            return this.internalMonitor.getInitialSourceClientOffset();
          }
        }, {
          key: "getSourceClientOffset",
          value: function getSourceClientOffset() {
            return this.internalMonitor.getSourceClientOffset();
          }
        }, {
          key: "getClientOffset",
          value: function getClientOffset() {
            return this.internalMonitor.getClientOffset();
          }
        }, {
          key: "getDifferenceFromInitialOffset",
          value: function getDifferenceFromInitialOffset() {
            return this.internalMonitor.getDifferenceFromInitialOffset();
          }
        }]), DropTargetMonitorImpl;
      }();
    function drop_slicedToArray(e, t) {
      return function drop_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function drop_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function drop_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return drop_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return drop_arrayLikeToArray(e, t);
      }(e, t) || function drop_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function drop_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function useDrop_slicedToArray(e, t) {
      return function useDrop_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function useDrop_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function useDrop_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return useDrop_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return useDrop_arrayLikeToArray(e, t);
      }(e, t) || function useDrop_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function useDrop_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function useDrop(e) {
      var t = Object(C.useRef)(e);
      t.current = e, Object(en.a)(null != e.accept, "accept must be defined");
      var r = useDrop_slicedToArray(function useDropTargetMonitor() {
          var e = useDragDropManager();
          return [Object(C.useMemo)(function () {
            return new an(e);
          }, [e]), Object(C.useMemo)(function () {
            return new nn(e.getBackend());
          }, [e])];
        }(), 2),
        n = r[0],
        o = r[1];
      !function useDropHandler(e, t, r) {
        var n = useDragDropManager(),
          o = Object(C.useMemo)(function () {
            return {
              canDrop: function canDrop() {
                var canDrop = e.current.canDrop;
                return !canDrop || canDrop(t.getItem(), t);
              },
              hover: function hover() {
                var hover = e.current.hover;
                hover && hover(t.getItem(), t);
              },
              drop: function drop() {
                var drop = e.current.drop;
                if (drop) return drop(t.getItem(), t);
              }
            };
          }, [t]);
        tn(function registerHandler() {
          var i = drop_slicedToArray(function registerTarget(e, t, r) {
              var n = r.getRegistry(),
                o = n.addTarget(e, t);
              return [o, function () {
                return n.removeTarget(o);
              }];
            }(e.current.accept, o, n), 2),
            a = i[0],
            c = i[1];
          return t.receiveHandlerId(a), r.receiveHandlerId(a), c;
        }, [t, r]);
      }(t, n, o);
      var i = useMonitorOutput(n, t.current.collect || function () {
          return {};
        }, function () {
          return o.reconnect();
        }),
        a = Object(C.useMemo)(function () {
          return o.hooks.dropTarget();
        }, [o]);
      return tn(function () {
        o.dropTargetOptions = e.options || null, o.reconnect();
      }, [e.options]), [i, a];
    }
    function DragSourceMonitorImpl_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var cn = !1,
      un = !1,
      sn = function () {
        function DragSourceMonitorImpl(e) {
          !function DragSourceMonitorImpl_classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, DragSourceMonitorImpl), this.sourceId = null, this.internalMonitor = e.getMonitor();
        }
        return function DragSourceMonitorImpl_createClass(e, t, r) {
          return t && DragSourceMonitorImpl_defineProperties(e.prototype, t), r && DragSourceMonitorImpl_defineProperties(e, r), e;
        }(DragSourceMonitorImpl, [{
          key: "receiveHandlerId",
          value: function receiveHandlerId(e) {
            this.sourceId = e;
          }
        }, {
          key: "getHandlerId",
          value: function getHandlerId() {
            return this.sourceId;
          }
        }, {
          key: "canDrag",
          value: function canDrag() {
            Object(en.a)(!cn, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
            try {
              return cn = !0, this.internalMonitor.canDragSource(this.sourceId);
            } finally {
              cn = !1;
            }
          }
        }, {
          key: "isDragging",
          value: function isDragging() {
            if (!this.sourceId) return !1;
            Object(en.a)(!un, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
            try {
              return un = !0, this.internalMonitor.isDraggingSource(this.sourceId);
            } finally {
              un = !1;
            }
          }
        }, {
          key: "subscribeToStateChange",
          value: function subscribeToStateChange(e, t) {
            return this.internalMonitor.subscribeToStateChange(e, t);
          }
        }, {
          key: "isDraggingSource",
          value: function isDraggingSource(e) {
            return this.internalMonitor.isDraggingSource(e);
          }
        }, {
          key: "isOverTarget",
          value: function isOverTarget(e, t) {
            return this.internalMonitor.isOverTarget(e, t);
          }
        }, {
          key: "getTargetIds",
          value: function getTargetIds() {
            return this.internalMonitor.getTargetIds();
          }
        }, {
          key: "isSourcePublic",
          value: function isSourcePublic() {
            return this.internalMonitor.isSourcePublic();
          }
        }, {
          key: "getSourceId",
          value: function getSourceId() {
            return this.internalMonitor.getSourceId();
          }
        }, {
          key: "subscribeToOffsetChange",
          value: function subscribeToOffsetChange(e) {
            return this.internalMonitor.subscribeToOffsetChange(e);
          }
        }, {
          key: "canDragSource",
          value: function canDragSource(e) {
            return this.internalMonitor.canDragSource(e);
          }
        }, {
          key: "canDropOnTarget",
          value: function canDropOnTarget(e) {
            return this.internalMonitor.canDropOnTarget(e);
          }
        }, {
          key: "getItemType",
          value: function getItemType() {
            return this.internalMonitor.getItemType();
          }
        }, {
          key: "getItem",
          value: function getItem() {
            return this.internalMonitor.getItem();
          }
        }, {
          key: "getDropResult",
          value: function getDropResult() {
            return this.internalMonitor.getDropResult();
          }
        }, {
          key: "didDrop",
          value: function didDrop() {
            return this.internalMonitor.didDrop();
          }
        }, {
          key: "getInitialClientOffset",
          value: function getInitialClientOffset() {
            return this.internalMonitor.getInitialClientOffset();
          }
        }, {
          key: "getInitialSourceClientOffset",
          value: function getInitialSourceClientOffset() {
            return this.internalMonitor.getInitialSourceClientOffset();
          }
        }, {
          key: "getSourceClientOffset",
          value: function getSourceClientOffset() {
            return this.internalMonitor.getSourceClientOffset();
          }
        }, {
          key: "getClientOffset",
          value: function getClientOffset() {
            return this.internalMonitor.getClientOffset();
          }
        }, {
          key: "getDifferenceFromInitialOffset",
          value: function getDifferenceFromInitialOffset() {
            return this.internalMonitor.getDifferenceFromInitialOffset();
          }
        }]), DragSourceMonitorImpl;
      }();
    function SourceConnector_defineProperties(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var ln = function () {
      function SourceConnector(e) {
        var t = this;
        !function SourceConnector_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, SourceConnector), this.hooks = wrapConnectorHooks({
          dragSource: function dragSource(e, r) {
            t.clearDragSource(), t.dragSourceOptions = r || null, isRef(e) ? t.dragSourceRef = e : t.dragSourceNode = e, t.reconnectDragSource();
          },
          dragPreview: function dragPreview(e, r) {
            t.clearDragPreview(), t.dragPreviewOptions = r || null, isRef(e) ? t.dragPreviewRef = e : t.dragPreviewNode = e, t.reconnectDragPreview();
          }
        }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
      }
      return function SourceConnector_createClass(e, t, r) {
        return t && SourceConnector_defineProperties(e.prototype, t), r && SourceConnector_defineProperties(e, r), e;
      }(SourceConnector, [{
        key: "receiveHandlerId",
        value: function receiveHandlerId(e) {
          this.handlerId !== e && (this.handlerId = e, this.reconnect());
        }
      }, {
        key: "reconnect",
        value: function reconnect() {
          this.reconnectDragSource(), this.reconnectDragPreview();
        }
      }, {
        key: "reconnectDragSource",
        value: function reconnectDragSource() {
          var e = this.dragSource,
            t = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
          t && this.disconnectDragSource(), this.handlerId && (e ? t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)) : this.lastConnectedDragSource = e);
        }
      }, {
        key: "reconnectDragPreview",
        value: function reconnectDragPreview() {
          var e = this.dragPreview,
            t = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
          t && this.disconnectDragPreview(), this.handlerId && (e ? t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = e, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, e, this.dragPreviewOptions)) : this.lastConnectedDragPreview = e);
        }
      }, {
        key: "didHandlerIdChange",
        value: function didHandlerIdChange() {
          return this.lastConnectedHandlerId !== this.handlerId;
        }
      }, {
        key: "didConnectedDragSourceChange",
        value: function didConnectedDragSourceChange() {
          return this.lastConnectedDragSource !== this.dragSource;
        }
      }, {
        key: "didConnectedDragPreviewChange",
        value: function didConnectedDragPreviewChange() {
          return this.lastConnectedDragPreview !== this.dragPreview;
        }
      }, {
        key: "didDragSourceOptionsChange",
        value: function didDragSourceOptionsChange() {
          return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
        }
      }, {
        key: "didDragPreviewOptionsChange",
        value: function didDragPreviewOptionsChange() {
          return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
        }
      }, {
        key: "disconnectDragSource",
        value: function disconnectDragSource() {
          this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
        }
      }, {
        key: "disconnectDragPreview",
        value: function disconnectDragPreview() {
          this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
        }
      }, {
        key: "clearDragSource",
        value: function clearDragSource() {
          this.dragSourceNode = null, this.dragSourceRef = null;
        }
      }, {
        key: "clearDragPreview",
        value: function clearDragPreview() {
          this.dragPreviewNode = null, this.dragPreviewRef = null;
        }
      }, {
        key: "connectTarget",
        get: function get() {
          return this.dragSource;
        }
      }, {
        key: "dragSourceOptions",
        get: function get() {
          return this.dragSourceOptionsInternal;
        },
        set: function set(e) {
          this.dragSourceOptionsInternal = e;
        }
      }, {
        key: "dragPreviewOptions",
        get: function get() {
          return this.dragPreviewOptionsInternal;
        },
        set: function set(e) {
          this.dragPreviewOptionsInternal = e;
        }
      }, {
        key: "dragSource",
        get: function get() {
          return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
        }
      }, {
        key: "dragPreview",
        get: function get() {
          return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
        }
      }]), SourceConnector;
    }();
    function drag_slicedToArray(e, t) {
      return function drag_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function drag_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function drag_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return drag_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return drag_arrayLikeToArray(e, t);
      }(e, t) || function drag_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function drag_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function drag_typeof(e) {
      return (drag_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function useDrag_slicedToArray(e, t) {
      return function useDrag_arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function useDrag_iterableToArrayLimit(e, t) {
        if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var r = [],
          n = !0,
          o = !1,
          i = void 0;
        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (u) {
          o = !0, i = u;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }
        return r;
      }(e, t) || function useDrag_unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return useDrag_arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return useDrag_arrayLikeToArray(e, t);
      }(e, t) || function useDrag_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function useDrag_arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function useDrag(e) {
      var t = Object(C.useRef)(e);
      t.current = e, Object(en.a)(null != e.item, "item must be defined"), Object(en.a)(null != e.item.type, "item type must be defined");
      var r = useDrag_slicedToArray(function useDragSourceMonitor() {
          var e = useDragDropManager();
          return [Object(C.useMemo)(function () {
            return new sn(e);
          }, [e]), Object(C.useMemo)(function () {
            return new ln(e.getBackend());
          }, [e])];
        }(), 2),
        n = r[0],
        o = r[1];
      !function useDragHandler(e, t, r) {
        var n = useDragDropManager(),
          o = Object(C.useMemo)(function () {
            return {
              beginDrag: function beginDrag() {
                var r = e.current,
                  n = r.begin,
                  o = r.item;
                if (n) {
                  var i = n(t);
                  return Object(en.a)(null == i || "object" === drag_typeof(i), "dragSpec.begin() must either return an object, undefined, or null"), i || o || {};
                }
                return o || {};
              },
              canDrag: function canDrag() {
                return "boolean" === typeof e.current.canDrag ? e.current.canDrag : "function" !== typeof e.current.canDrag || e.current.canDrag(t);
              },
              isDragging: function isDragging(r, n) {
                var isDragging = e.current.isDragging;
                return isDragging ? isDragging(t) : n === r.getSourceId();
              },
              endDrag: function endDrag() {
                var n = e.current.end;
                n && n(t.getItem(), t), r.reconnect();
              }
            };
          }, []);
        tn(function registerHandler() {
          var i = drag_slicedToArray(function registerSource(e, t, r) {
              var n = r.getRegistry(),
                o = n.addSource(e, t);
              return [o, function () {
                return n.removeSource(o);
              }];
            }(e.current.item.type, o, n), 2),
            a = i[0],
            c = i[1];
          return t.receiveHandlerId(a), r.receiveHandlerId(a), c;
        }, []);
      }(t, n, o);
      var i = useMonitorOutput(n, t.current.collect || function () {
          return {};
        }, function () {
          return o.reconnect();
        }),
        a = Object(C.useMemo)(function () {
          return o.hooks.dragSource();
        }, [o]),
        c = Object(C.useMemo)(function () {
          return o.hooks.dragPreview();
        }, [o]);
      return tn(function () {
        o.dragSourceOptions = t.current.options || null, o.reconnect();
      }, [o]), tn(function () {
        o.dragPreviewOptions = t.current.previewOptions || null, o.reconnect();
      }, [o]), [i, a, c];
    }
    var dn,
      fn,
      pn,
      hn = function DragHandleIcon() {
        return T.a.createElement("svg", {
          width: "8",
          height: "12",
          viewBox: "0 0 8 12",
          className: "onboarding-dnd-item-handle",
          fill: "none"
        }, T.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.86665 2.79984C2.45576 2.79984 2.93332 2.32227 2.93332 1.73317C2.93332 1.14407 2.45576 0.666504 1.86665 0.666504C1.27755 0.666504 0.799988 1.14407 0.799988 1.73317C0.799988 2.32227 1.27755 2.79984 1.86665 2.79984ZM1.86665 7.0665C2.45576 7.0665 2.93332 6.58894 2.93332 5.99984C2.93332 5.41073 2.45576 4.93317 1.86665 4.93317C1.27755 4.93317 0.799988 5.41073 0.799988 5.99984C0.799988 6.58894 1.27755 7.0665 1.86665 7.0665ZM2.93332 10.2665C2.93332 10.8556 2.45576 11.3332 1.86665 11.3332C1.27755 11.3332 0.799988 10.8556 0.799988 10.2665C0.799988 9.6774 1.27755 9.19984 1.86665 9.19984C2.45576 9.19984 2.93332 9.6774 2.93332 10.2665ZM6.13332 2.79984C6.72242 2.79984 7.19999 2.32227 7.19999 1.73317C7.19999 1.14407 6.72242 0.666504 6.13332 0.666504C5.54422 0.666504 5.06665 1.14407 5.06665 1.73317C5.06665 2.32227 5.54422 2.79984 6.13332 2.79984ZM7.19999 5.99984C7.19999 6.58894 6.72242 7.0665 6.13332 7.0665C5.54422 7.0665 5.06665 6.58894 5.06665 5.99984C5.06665 5.41073 5.54422 4.93317 6.13332 4.93317C6.72242 4.93317 7.19999 5.41073 7.19999 5.99984ZM6.13332 11.3332C6.72242 11.3332 7.19999 10.8556 7.19999 10.2665C7.19999 9.6774 6.72242 9.19984 6.13332 9.19984C5.54422 9.19984 5.06665 9.6774 5.06665 10.2665C5.06665 10.8556 5.54422 11.3332 6.13332 11.3332Z",
          fill: "#94c8ff"
        }));
      },
      gn = function OrgGoal(e) {
        var t = e.goal,
          r = e.index,
          n = e.onDeleteClick,
          o = e.onMove,
          i = e.className,
          a = Object(C.useRef)(null),
          c = _slicedToArray(useDrop({
            accept: "OrgGoal",
            hover: function hover(e, t) {
              if (a.current) {
                var n = e.index,
                  i = r;
                if (n !== i) {
                  var c = a.current.getBoundingClientRect(),
                    u = (c.bottom - c.top) / 2,
                    s = t.getClientOffset().y - c.top;
                  n < i && s < u || n > i && s > u || (o(n, i), e.index = i);
                }
              }
            }
          }), 2)[1],
          u = _slicedToArray(useDrag({
            item: {
              type: "OrgGoal",
              id: t.id,
              index: r
            },
            collect: function collect(e) {
              return {
                isDragging: e.isDragging()
              };
            }
          }), 2),
          s = u[0].isDragging;
        (0, u[1])(c(a));
        var l = {
          opacity: +!s,
          cursor: s && "grabbing"
        };
        return T.a.createElement("div", {
          ref: a,
          style: l,
          className: Nr()(i, "onboarding-dnd-item")
        }, T.a.createElement("span", {
          className: "onboarding-dnd-item-content"
        }, T.a.createElement(hn, null), T.a.createElement("span", {
          className: "onboarding-dnd-item-title"
        }, r + 1, ". ", t.title)), T.a.createElement(Rr.IconButton, {
          icon: "cancel-circle",
          onClick: n
        }));
      },
      bn = (i(30), function GoalDnd(e) {
        var t = e.className,
          r = e.titleClassName,
          n = e.itemClassName,
          o = e.emptyItemClassName,
          i = _objectWithoutProperties(e, ["className", "titleClassName", "itemClassName", "emptyItemClassName"]),
          c = Dr(y.getExistingGoals),
          u = ft.isEmpty(c.funnelGoals) ? c.valueGoals : c.funnelGoals,
          s = Dr(y.getFetchOrgGoalsLoading),
          l = _r({
            updateOrgGoals: a.updateOrgGoals
          }),
          d = Object(C.useCallback)(function (e, t) {
            var r = toConsumableArray_toConsumableArray(u);
            r.splice(t, 0, r.splice(e, 1)[0]), l.updateOrgGoals(r);
          }, [l, u]),
          f = function renderOrgGoal(e, t) {
            return T.a.createElement(gn, {
              className: n,
              goal: e,
              key: e.id,
              index: t,
              onDeleteClick: function onDeleteClick() {
                return function onDeleteClick(e) {
                  return l.updateOrgGoals(ft.without([e], u));
                }(e);
              },
              onMove: d
            });
          },
          p = ft.range(0, 3).map(function (e) {
            return T.a.createElement(Rr.Div, {
              key: e,
              className: Nr()(n, o, "onboarding-dnd-item onboarding-dnd-item--empty")
            }, e + 1, ". Key metric ", !e && "(required)");
          });
        return s ? null : T.a.createElement(Zr.a, {
          backend: Qr
        }, T.a.createElement(Rr.CardContainer, Object.assign({
          className: Nr()(t, "onboarding-dnd-container")
        }, i), T.a.createElement(Rr.H5, {
          className: Nr()(r, "onboarding-dnd-container-title")
        }, "Your key metrics"), u.map(function (e, t) {
          return f(e, t);
        }), p.slice(u.length)));
      }),
      yn = function Cards(e) {
        var t = e.className,
          r = Dr(y.getExistingGoals),
          n = ft.isEmpty(r.funnelGoals) ? r.valueGoals : r.funnelGoals,
          o = _r({
            updateOrgGoals: a.updateOrgGoals
          });
        return vt.map(function (e) {
          var r,
            i = n.filter(function (t) {
              var r = t.id;
              return e.id === r;
            }).length,
            a = n.length >= 4 && !i,
            c = "onboarding-goal-selection-card",
            u = function postfixClass(e) {
              return "".concat(c, "--").concat(e);
            },
            s = Nr()("oc", c, t, (_defineProperty(r = {}, u("selected"), i), _defineProperty(r, u("disabled"), a), r));
          return T.a.createElement(Rr.CardContainer, {
            className: s,
            onClick: function onClick() {
              if (!a) {
                var t = i ? ft.without([e], n) : ft.append(e, n);
                o.updateOrgGoals(t);
              }
            },
            key: e.id,
            boxShadow: "none"
          }, T.a.createElement(Rr.Div, {
            className: "onboarding-goal-selection-card-header"
          }, T.a.createElement(Rr.Span, {
            className: "onboarding-goal-selection-card-label"
          }, e.funnelPosition), T.a.createElement(Rr.Input, {
            type: "checkbox",
            className: "oc checkbox",
            checked: i,
            disabled: a
          })), T.a.createElement(Rr.H4, {
            className: "onboarding-goal-selection-card-goal-title"
          }, e.title), T.a.createElement(Rr.Span, {
            className: "onboarding-goal-selection-card-goal-description"
          }, e.description));
        });
      },
      vn = (i(32), function GoalSelection(e) {
        var t = e.className,
          r = e.cardContainerClassName,
          n = e.cardClassName,
          o = _objectWithoutProperties(e, ["className", "cardContainerClassName", "cardClassName"]);
        return Dr(y.getFetchOrgGoalsLoading) ? null : T.a.createElement(Rr.Div, Object.assign({
          className: Nr()(t, "onboarding-goal-selection")
        }, o), T.a.createElement(Rr.H3, null, "What outcomes do you want to work towards with Drift?"), T.a.createElement(Rr.P, null, "We'll help you get set up to work towards these goals. Select up to 4:"), T.a.createElement(Rr.Div, {
          className: Nr()(r, "onboarding-goal-selection-card-container")
        }, T.a.createElement(yn, {
          className: n
        })));
      }),
      mn = (i(34), function GoalEditModal(e) {
        var t = e.onClose,
          r = e.open,
          n = Dr(y.getOrgGoals),
          o = _slicedToArray(Object(C.useState)(n), 2),
          i = o[0],
          c = o[1],
          u = ft.isEmpty(n),
          s = Dr(y.getSaveOrgGoalsLoading),
          l = _r({
            updateOrgGoals: a.updateOrgGoals,
            saveOrgGoals: a.saveOrgGoals
          }),
          d = function handleClose() {
            l.updateOrgGoals(i), t();
          },
          f = T.a.createElement(bn, {
            className: "oc-modal-goal-dnd"
          }),
          p = T.a.createElement(T.a.Fragment, null, T.a.createElement(Rr.Button, {
            onClick: function onUpdateClick() {
              c(n), l.saveOrgGoals({
                callback: t
              });
            },
            loading: s,
            disabled: u
          }, "Update"), T.a.createElement(Rr.Button, {
            type: "tertiary",
            onClick: d
          }, "Cancel"));
        return Br.a.createPortal(T.a.createElement(Rr.Modal, {
          graySpaceContent: f,
          onClose: d,
          footerCopy: p,
          open: r,
          size: "fullscreen"
        }, T.a.createElement(vn, null)), document.body);
      }),
      On = function wrapStrong(e) {
        return T.a.createElement(Rr.Strong, {
          key: e
        }, e);
      },
      Sn = function mapToHumanizedList(e) {
        return e.map(function (t, r) {
          var n;
          return 1 === r && 2 === e.length ? n = " and " : r && r === e.length - 1 ? n = ", and " : r && (n = ", "), [n, t];
        });
      },
      _n = function GoalCopy() {
        return ft.pipe(ft.pluck(Ot.title), ft.map(On), Sn)(Dr(y.getOrgGoals));
      },
      An = i(21),
      wn = function TargetIcon() {
        return T.a.createElement(Rr.Colorway, {
          type: "3",
          className: "oc target-icon"
        }, T.a.createElement(An.Icon, {
          name: "liveView",
          width: "32",
          height: "32"
        }));
      },
      En = (i(36), function GoalPreviewCard(e) {
        var t = e.className,
          r = _objectWithoutProperties(e, ["className"]),
          n = _slicedToArray(Object(C.useReducer)(ft.not, !1), 2),
          o = n[0],
          i = n[1],
          a = Dr(y.getFetchOrgGoalsLoading),
          c = Dr(y.getExistingGoals),
          u = !ft.isEmpty(c.funnelGoals),
          s = u ? c.funnelGoals : c.valueGoals,
          l = !ft.isEmpty(s);
        return T.a.createElement(Rr.CardContainer, Object.assign({
          className: Nr()(t, a && "goal-preview-card--loading", "oc goal-preview-card")
        }, r), a ? T.a.createElement(Rr.ProgressiveLoader, {
          placeholderShape: T.a.createElement("rect", {
            x: "0",
            y: "0",
            width: "400",
            height: "24"
          }),
          options: {
            width: 400,
            height: 24
          },
          numPlaceholders: 1
        }) : T.a.createElement(T.a.Fragment, null, T.a.createElement(wn, null), function renderCopy() {
          return u ? T.a.createElement(Rr.Span, null, T.a.createElement(Rr.Strong, null, "Update your goals with our new metrics!"), T.a.createElement("br", null), "Current goals: \xa0", T.a.createElement(Rr.Span, {
            className: "goal-preview-card-goals"
          }, T.a.createElement(_n, null))) : l ? T.a.createElement(Rr.Span, null, T.a.createElement(Rr.Strong, null, "Your goal with Drift is to: "), T.a.createElement(Rr.Span, {
            className: "goal-preview-card-goals"
          }, T.a.createElement(_n, null))) : T.a.createElement(Rr.Span, null, T.a.createElement(Rr.Strong, null, "What outcomes do you want to work towards with Drift?"), T.a.createElement("br", null), "Select your goals and we'll work with your team to help reach success!");
        }(), function renderButton() {
          return u ? T.a.createElement(Rr.Button, {
            type: "tertiary",
            onClick: i
          }, "Update now") : l ? T.a.createElement(Rr.Button, {
            type: "tertiary",
            onClick: i
          }, "Edit goals") : T.a.createElement(Rr.Button, {
            type: "tertiary",
            onClick: i
          }, "Select outcomes");
        }(), T.a.createElement(mn, {
          onClose: i,
          open: o
        })));
      }),
      Cn = i(4),
      Tn = i(22),
      Dn = i(23),
      In = i(24),
      jn = i(25),
      kn = Object.freeze({
        SALES: "SALES",
        MARKETING: "MARKETING",
        SERVICE: "SERVICE",
        OTHER: "OTHER"
      }),
      xn = Object.freeze((_defineProperty(dn = {}, kn.SALES, {
        area: "Sales",
        faIcon: Tn.faChartColumn
      }), _defineProperty(dn, kn.MARKETING, {
        area: "Marketing",
        faIcon: Dn.faChartPieSimple
      }), _defineProperty(dn, kn.SERVICE, {
        area: "Service",
        faIcon: jn.faPhone
      }), _defineProperty(dn, kn.OTHER, {
        area: "Other",
        faIcon: In.faMagnifyingGlass
      }), dn)),
      Pn = Object.freeze((_defineProperty(fn = {}, kn.SALES, "e.g. Sales Development Representative"), _defineProperty(fn, kn.MARKETING, "e.g. Marketing Operations"), _defineProperty(fn, kn.SERVICE, "e.g. Service Chat Rep"), _defineProperty(fn, kn.OTHER, "e.g. Engineer"), fn)),
      Mn = Object.freeze((_defineProperty(pn = {}, kn.SALES, ["Handle inbound sales leads", "Find prospects, do outbound prospecting with them", "Handle inbound and outbound leads", "Close sales deals", "Manage a team that prospects inbound and/or outbound leads", "Manage a team of sales representatives who close deals", "Other"]), _defineProperty(pn, kn.MARKETING, ["Own chatbot", "Own chatbot reporting", "Own chatbot and reporting", "Manage a team/person who owns chatbot", "Manage a team/person who owns chatbot reporting", "Manage a team/person who owns chatbot and reporting", "Set up or configure marketing technology platforms", "Other"]), _defineProperty(pn, kn.SERVICE, ["Handle support chats", "Own service chatbot and reporting", "Manage a team/person who owns service chatbot and reporting", "Manage a team/person who answers support chats", "Create service chatbots and manage a team who answers support chats", "Other"]), _defineProperty(pn, kn.OTHER, []), pn)),
      Nn = Object(Cn.styled)(Cn.SelectionTile.Item, {
        alignItems: "center",
        flexGrow: "unset",
        minWidth: "100px"
      }),
      Rn = function JobAreaCards(e) {
        var t = e.onSelectJobArea,
          r = void 0 === t ? function () {} : t,
          n = e.area;
        return T.a.createElement(Cn.Flex, {
          direction: "column",
          alignItems: "center",
          fullWidth: !0
        }, T.a.createElement(Cn.Text, null, "What area is your role in?"), T.a.createElement(Cn.SelectionTile.Group, {
          as: Cn.SimpleGrid,
          gap: 2,
          columns: 4,
          direction: "row",
          alignItems: "center",
          justifyContent: "center",
          onChange: function onChange(e) {
            return r(e);
          },
          defaultValue: n || kn.SALES
        }, ft.map(function (e) {
          var t = xn[e],
            r = t.area,
            n = t.faIcon;
          return T.a.createElement(Nn, {
            key: e,
            id: e
          }, T.a.createElement(Cn.Icon, {
            icon: n,
            variant: "dark",
            size: "large"
          }), T.a.createElement(Cn.Header, {
            variant: "h3"
          }, r));
        }, ft.keys(xn))));
      },
      Ln = function JobTasks(e) {
        var t = e.task,
          r = e.onChangeTask,
          n = void 0 === r ? function () {} : r,
          o = e.tasks,
          i = void 0 === o ? [] : o;
        return !ft.isEmpty(i) && T.a.createElement(Cn.RadioGroup, {
          label: "What best describes your responsibilities?",
          value: t,
          onValueChange: n
        }, ft.map(function (e) {
          return T.a.createElement(Cn.RadioItem, {
            key: e,
            value: e,
            label: e
          });
        }, i));
      },
      Bn = function JobTitle(e) {
        var t = e.title,
          r = e.onChangeTitle,
          n = void 0 === r ? function () {} : r,
          o = e.placeholder,
          i = void 0 === o ? "" : o;
        return T.a.createElement(Cn.InputText, {
          className: "onboarding-job-title",
          label: "What is your title?",
          value: t,
          placeholder: i,
          size: "full-width",
          onChange: function onChange(e) {
            return n(e.target.value);
          },
          description: "This will appear on your Drift Profile, and can be easily updated later in \u201CMy Settings\u201D"
        });
      },
      Gn = Object(Cn.styled)(Cn.Flex, {
        paddingBottom: "$2"
      }),
      Hn = Object(Cn.styled)(Cn.Text, {
        textAlign: "center"
      }),
      Fn = function JobDesignation(e) {
        var t = e.tasks,
          r = void 0 === t ? [] : t,
          n = e.title,
          o = void 0 === n ? "" : n,
          i = e.area,
          a = e.onUpdateTask,
          c = void 0 === a ? function () {} : a,
          u = e.onUpdateTitle,
          s = void 0 === u ? function () {} : u,
          l = e.onUpdateArea,
          d = void 0 === l ? function () {} : l,
          f = e.description,
          p = void 0 === f ? "Help us understand your current role and responsibilities so we can give you the best experience in Drift" : f,
          h = e.hideJobTitleField,
          g = void 0 !== h && h,
          b = Object(C.useMemo)(function () {
            return Pn[i];
          }, [i]),
          y = Object(C.useMemo)(function () {
            return Mn[i];
          }, [i]);
        return T.a.createElement(Gn, {
          direction: "column",
          className: "onboarding-job-tasks-step",
          gap: 3
        }, T.a.createElement(Cn.Flex, {
          direction: "column",
          fullWidth: !0,
          alignItems: "center"
        }, T.a.createElement(Hn, null, p)), T.a.createElement(Rn, {
          onSelectJobArea: d,
          area: i
        }), !g && T.a.createElement(Bn, {
          title: o,
          onChangeTitle: s,
          placeholder: b
        }), T.a.createElement(Ln, {
          tasks: y,
          task: r[0],
          onChangeTask: c
        }));
      },
      Un = i(15),
      zn = i.n(Un);
    function asyncGeneratorStep(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
          u = c.value;
      } catch (s) {
        return void r(s);
      }
      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }
    var qn = function useJobTasks() {
        var e = _slicedToArray(Object(C.useState)(!1), 2),
          t = e[0],
          r = e[1],
          n = _slicedToArray(Object(C.useState)(!1), 2),
          o = n[0],
          i = n[1],
          a = Object(C.useCallback)(function (e) {
            var t = e.payload,
              n = e.onSuccess,
              o = void 0 === n ? function () {} : n,
              i = e.onError,
              a = void 0 === i ? function () {} : i;
            return r(function () {
              return !0;
            }, vr.post("/job-tasks", t).then(function (e) {
              return r(function () {
                return !1;
              }, o(e));
            }).catch(function (e) {
              return r(function () {
                return !1;
              }, a(e));
            }));
          }, []),
          c = Object(C.useCallback)(function (e) {
            var t = e.userId,
              r = e.onSuccess,
              n = void 0 === r ? function () {} : r,
              o = e.onError,
              a = void 0 === o ? function () {} : o;
            return i(function () {
              return !0;
            }, vr.get("/job-tasks/".concat(t)).then(function (e) {
              return i(function () {
                return !1;
              }, n(e));
            }).catch(function (e) {
              return i(function () {
                return !1;
              }, a(e));
            }));
          }, []);
        return Object(C.useMemo)(function () {
          return {
            updateJobTasks: a,
            getJobTasks: c,
            isUpdatingJobTasks: t,
            isFetchingJobTasks: o
          };
        }, [a, c, t, o]);
      },
      Wn = function useJobTitle(e) {
        var t = e.userId,
          r = _slicedToArray(Object(C.useState)(!1), 2),
          n = r[0],
          o = r[1],
          i = Object(C.useCallback)(function (e) {
            return [{
              operation: "set",
              property: "jobTitle",
              value: e
            }];
          }, []),
          a = Object(C.useCallback)(function (e) {
            var r = e.title,
              n = e.onSuccess,
              a = void 0 === n ? function () {} : n,
              c = e.onError,
              u = void 0 === c ? function () {} : c;
            return o(function () {
              return !0;
            }, mr.patch("/users/".concat(t, "/profile"), i(r)).then(function (e) {
              return o(function () {
                return !1;
              }, a(e));
            }).catch(function (e) {
              return o(function () {
                return !1;
              }, u(e));
            }));
          }, [i, t]);
        return Object(C.useMemo)(function () {
          return {
            updateJobTitle: a,
            loading: n
          };
        }, [a, n]);
      },
      Vn = function useJobDesignation(e) {
        var t = e.userId,
          r = e.hasProfile,
          n = void 0 !== r && r,
          o = e.hideJobTitleField,
          i = void 0 !== o && o,
          a = e.onComplete,
          c = void 0 === a ? function () {} : a,
          u = e.onTrack,
          s = void 0 === u ? function () {} : u,
          l = _slicedToArray(Object(C.useState)(kn.SALES), 2),
          d = l[0],
          f = l[1],
          p = _slicedToArray(Object(C.useState)(""), 2),
          h = p[0],
          g = p[1],
          b = _slicedToArray(Object(C.useState)([]), 2),
          y = b[0],
          v = b[1],
          m = qn(),
          O = m.updateJobTasks,
          S = m.isUpdatingJobTasks,
          _ = m.isFetchingJobTasks,
          A = m.getJobTasks,
          w = Wn({
            userId: t
          }),
          E = w.updateJobTitle,
          T = w.loading,
          D = Object(C.useCallback)(function (e) {
            var t = e.onSuccess,
              r = void 0 === t ? function () {} : t,
              n = e.onError;
            return E({
              title: h,
              onSuccess: r,
              onError: void 0 === n ? function () {} : n
            });
          }, [h, E]),
          I = Object(C.useCallback)(function (e) {
            var r = e.onSuccess,
              n = void 0 === r ? function () {} : r,
              o = e.onError;
            return A({
              userId: t,
              onSuccess: function onSuccess(e) {
                var t = e || {},
                  r = t.tasks,
                  o = t.area,
                  i = t.title;
                v(r), f(o), g(i), n(e);
              },
              onError: void 0 === o ? function () {} : o
            });
          }, [A, t]),
          j = Object(C.useCallback)(function (e) {
            var t = e.onSuccess,
              r = void 0 === t ? function () {} : t,
              n = e.onError;
            return O({
              payload: {
                tasks: y,
                title: h,
                area: d
              },
              onSuccess: r,
              onError: void 0 === n ? function () {} : n
            });
          }, [y, h, d, O]),
          k = Object(C.useCallback)(function _asyncToGenerator(e) {
            return function () {
              var t = this,
                r = arguments;
              return new Promise(function (n, o) {
                var i = e.apply(t, r);
                function _next(e) {
                  asyncGeneratorStep(i, n, o, _next, _throw, "next", e);
                }
                function _throw(e) {
                  asyncGeneratorStep(i, n, o, _next, _throw, "throw", e);
                }
                _next(void 0);
              });
            };
          }(zn.a.mark(function _callee() {
            return zn.a.wrap(function _callee$(e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (s({
                      title: h,
                      tasks: y,
                      area: d
                    }), !n || !h || i) {
                      e.next = 6;
                      break;
                    }
                    return e.next = 4, D({
                      onSuccess: function onSuccess() {
                        return j({
                          onSuccess: function onSuccess() {
                            return c();
                          }
                        });
                      }
                    });
                  case 4:
                    e.next = 12;
                    break;
                  case 6:
                    if (!h && !y) {
                      e.next = 11;
                      break;
                    }
                    return e.next = 9, j({
                      onSuccess: function onSuccess() {
                        return c();
                      }
                    });
                  case 9:
                    e.next = 12;
                    break;
                  case 11:
                    c();
                  case 12:
                  case "end":
                    return e.stop();
                }
              }
            }, _callee);
          })), [j, D, n, c, s, h, y, d, i]);
        return Object(C.useMemo)(function () {
          return {
            onUpdate: k,
            onGetJobTasks: I,
            isUpdating: S || T,
            isFetching: _,
            tasks: y,
            title: h,
            area: d,
            onUpdateTasks: v,
            onUpdateTask: function onUpdateTask(e) {
              return v([e]);
            },
            onUpdateTitle: g,
            onUpdateArea: f
          };
        }, [d, I, k, _, S, T, y, h]);
      };
    i.d(o, "OnboardingProvider", function () {
      return Pr;
    }), i.d(o, "GoalPreviewCard", function () {
      return En;
    }), i.d(o, "GoalSelection", function () {
      return vn;
    }), i.d(o, "GoalDnd", function () {
      return bn;
    }), i.d(o, "useJobDesignation", function () {
      return Vn;
    }), i.d(o, "JobDesignation", function () {
      return Fn;
    }), i.d(o, "Goals", function () {
      return mt;
    }), i.d(o, "useOrgGoals", function () {
      return wr;
    }), i.d(o, "useSavingOrgGoals", function () {
      return Ar;
    }), i.d(o, "useSaveOrgGoals", function () {
      return Cr;
    }), i.d(o, "useUpdateOrgGoals", function () {
      return Er;
    });
  },,, function (e, t, r) {
    "use strict";

    (function (e) {
      r.d(t, "a", function () {
        return a;
      });
      var n = r(0),
        o = r(10);
      function _slicedToArray(e, t) {
        return function _arrayWithHoles(e) {
          if (Array.isArray(e)) return e;
        }(e) || function _iterableToArrayLimit(e, t) {
          if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(e))) return;
          var r = [],
            n = !0,
            o = !1,
            i = void 0;
          try {
            for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (u) {
            o = !0, i = u;
          } finally {
            try {
              n || null == c.return || c.return();
            } finally {
              if (o) throw i;
            }
          }
          return r;
        }(e, t) || function _unsupportedIterableToArray(e, t) {
          if (!e) return;
          if ("string" === typeof e) return _arrayLikeToArray(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          "Object" === r && e.constructor && (r = e.constructor.name);
          if ("Map" === r || "Set" === r) return Array.from(e);
          if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _arrayLikeToArray(e, t);
        }(e, t) || function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function _arrayLikeToArray(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) {
          n[r] = e[r];
        }
        return n;
      }
      function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var r,
          n,
          o = function _objectWithoutPropertiesLoose(e, t) {
            if (null == e) return {};
            var r,
              n,
              o = {},
              i = Object.keys(e);
            for (n = 0; n < i.length; n++) {
              r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            }
            return o;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          for (n = 0; n < i.length; n++) {
            r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
          }
        }
        return o;
      }
      var i = 0,
        a = Object(n.memo)(function (e) {
          var t = e.children,
            r = _slicedToArray(function getDndContextValue(e) {
              if ("manager" in e) {
                var t = {
                  dragDropManager: e.manager
                };
                return [t, !1];
              }
              var r = function createSingletonDndContext(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : getGlobalContext(),
                    r = arguments.length > 2 ? arguments[2] : void 0,
                    n = arguments.length > 3 ? arguments[3] : void 0,
                    i = t;
                  i[c] || (i[c] = Object(o.b)(e, t, r, n));
                  return i[c];
                }(e.backend, e.context, e.options, e.debugMode),
                n = !e.context;
              return [r, n];
            }(_objectWithoutProperties(e, ["children"])), 2),
            a = r[0],
            u = r[1];
          return n.useEffect(function () {
            return u && i++, function () {
              u && 0 === --i && (getGlobalContext()[c] = null);
            };
          }, []), n.createElement(o.a.Provider, {
            value: a
          }, t);
        });
      a.displayName = "DndProvider";
      var c = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
      function getGlobalContext() {
        return "undefined" !== typeof e ? e : window;
      }
    }).call(this, r(18));
  }]);
});